export const translations = {
  no: {
    nav: {
      home: 'Hjem',
      services: 'Behandlinger',
      about: 'Om Oss',
      courses: 'Kurs',
      giftcard: 'Gavekort',
      faq: 'FAQ',
      booking: 'Book Online',
      contact: 'Kontakt',
      book: 'Book Time'
    },
    waitlist: {
      button: 'Fant du ikke ledig time? Sett deg på venteliste',
      noTimesText: 'Ingen tider som passer? Sett deg på venteliste, vi får ofte ledige timer.',
      title: 'Sett deg på venteliste',
      subtitle: 'Fyll ut skjemaet så kontakter vi deg når noe blir ledig.',
      form: {
        name: 'Fullt navn',
        namePlaceholder: 'Ditt navn',
        phone: 'Telefonnummer',
        phonePlaceholder: '+47 XXX XX XXX',
        email: 'E-post',
        emailPlaceholder: 'din@epost.no',
        treatment: 'Ønsket behandling',
        treatmentPlaceholder: 'Velg behandling',
        treatments: {
          brazilianWax: 'Brasiliansk voks',
          bikiniWax: 'Bikini voks',
          fullLegs: 'Hele ben',
          halfLegs: 'Halve ben',
          underarms: 'Armhuler',
          arms: 'Armer',
          faceWax: 'Ansiktsvoks',
          koreanLashLift: 'Koreansk Vippeløft',
          lashFiller: 'Lash Filler Vippeløft',
          browLamination: 'Brynslaminering',
          hdBrows: 'HD Bryn',
          hybridTint: 'Hybridfarge bryn',
          gelNails: 'Gel Negler',
          facialTreatment: 'Ansiktsbehandling',
          other: 'Annet'
        },
        staff: 'Foretrukket behandler',
        staffPlaceholder: 'Velg behandler (valgfritt)',
        staffOptions: {
          noPreference: 'Ingen preferanse',
          kamilla: 'Kamilla',
          thea: 'Thea',
          lyra: 'Lyra',
          nora: 'Nora'
        },
        preferredDays: 'Foretrukne dager',
        days: {
          monday: 'Mandag',
          tuesday: 'Tirsdag',
          wednesday: 'Onsdag',
          thursday: 'Torsdag',
          friday: 'Fredag',
          saturday: 'Lørdag'
        },
        preferredTimes: 'Foretrukne tider',
        times: {
          morning: 'Morgen (09-12)',
          afternoon: 'Ettermiddag (12-15)',
          evening: 'Kveld (15-18)'
        },
        shortNotice: 'Kan du på kort varsel?',
        shortNoticeYes: 'Ja, ring meg gjerne',
        shortNoticeNo: 'Nei, jeg trenger mer tid',
        notes: 'Andre ønsker eller kommentarer',
        notesPlaceholder: 'Skriv her om du har spesielle ønsker...',
        submit: 'Sett meg på venteliste',
        submitting: 'Sender...'
      },
      success: {
        title: 'Takk! 🍑',
        message: 'Vi kontakter deg dersom noe blir ledig.',
        close: 'Lukk',
        shareTitle: 'Kjenner du noen andre som venter på time?',
        shareSubtitle: 'Del ventelisten – vi får ofte ledige timer på kort varsel.',
        shareWhatsapp: 'Del på WhatsApp',
        shareSms: 'Send som SMS',
        shareCopy: 'Kopier lenke',
        shareCopied: 'Lenke kopiert!',
        shareMessage: 'Hei! Just Peachy Bergen har en venteliste for ledige timer – de får ofte avbestillinger på kort varsel. Meld deg på her:'
      },
      homepage: {
        tagline: 'Fullbooket?',
        title: 'Sett deg på',
        titleHighlight: 'venteliste',
        description: 'Vi får ofte ledige timer på kort varsel. Legg igjen din informasjon, så kontakter vi deg når noe blir ledig.',
        cta: 'Sett meg på venteliste'
      }
    },
    hero: {
      tagline: 'Din Pause fra Hverdagen',
      title: 'Velkommen til',
      titleHighlight: 'Just Peachy Bergen',
      subtitle: 'Skjønnhet, velvære og litt ekstra egenomsorg.',
      subtitleLine2: 'Opplev en salong der hver behandling er skreddersydd for deg.',
      cta: 'Book Din Time',
      scrollText: 'Oppdag mer'
    },
    about: {
      tagline: 'Hvem Er Vi',
      title: 'Møt Kamilla',
      titleHighlight: '& Teamet',
      description: 'Hos Just Peachy Bergen handler det om mer enn bare behandlinger – det handler om følelsen du sitter igjen med. Et sted der det er rom for å være deg selv, ta en pause og bare være.',
      description2: 'Med over 10 års erfaring og tusenvis av fornøyde kunder, kombinerer vi høy fagkunnskap, sertifiserte teknikker og en varm, trygg atmosfære. Her kan du slappe av med en kopp kaffe mens vi tar vare på deg.',
      description3: 'Salongen ligger i Veiten 2B, midt i Bergen sentrum, med egen inngang på bakkeplan. Lett tilgjengelig og uten trapper!',
      experience: 'Års Erfaring',
      clients: 'Kunder Årlig',
      treatments: 'Behandlinger',
      cta: 'Book Hos Oss',
      video: {
        tagline: 'Bli Bedre Kjent',
        title: 'Et lite innblikk i',
        titleHighlight: 'hverdagen vår',
        description: 'Her kan du bli litt bedre kjent med meg og salongen. Jeg ble intervjuet om reisen min, hva som driver meg, og hva Just Peachy Bergen betyr for meg. Håper du liker det!'
      },
      team: {
        title: 'Møt Teamet',
        owner: {
          name: 'Kamilla',
          role: 'Eier og grunnlegger',
          description: 'Jeg er født i 1997 og kommer fra ei lita bygd i Nord Norge som heter Kvæfjord. Jeg har jobbet i skjønnhetsbransjen siden jeg var 17 år, og har elsket faget helt siden starten. For meg handler dette ikke bare om behandlinger, men om mennesker. Mange av kundene mine har fulgt meg i over ti år, og relasjonene vi bygger betyr utrolig mye.',
          description2: 'En av mine største drivkrefter er å ufarliggjøre voksing. Jeg ønsker å gjøre noe som mange gruer seg til, til en trygg og god opplevelse. Min drøm er å skape en salong der alle føler seg velkommen, ivaretatt og trives så godt at de nesten ikke vil dra.',
          description3: 'Jeg har pusset opp salongen selv med god hjelp fra Lyra og kjæresten min Kristian, og gjør alt fra nettside og sosiale medier til regnskap og utvikling på egen hånd. Det ligger mye kjærlighet bak hver eneste detalj.',
          description4: 'På fritiden liker jeg å synge, være kreativ og lage små prosjekter selv. Jeg har en katt som heter Stella som betyr veldig mye for meg.',
          description5: 'Jeg snakker både norsk og engelsk flytende, og ønsker deg varmt velkommen til Just Peachy Bergen 🤍'
        },
        staffTitle: 'Vårt Team',
        staff: [
          {
            name: 'Lyra',
            role: 'Skjønnhetsterapeut',
            description: 'Lyra har jobbet hos Just Peachy Bergen siden september 2025 og har raskt blitt en viktig del av teamet. Hun er nøye, rolig og opptatt av at alle kunder skal føle seg trygge og godt ivaretatt under behandlingene. Lyra snakker flytende norsk og engelsk.',
            description2: 'Hun tilbyr koreansk vippeløft, HD bryn, hybridbryn, brynslaminering, ansiktsvoks og full kroppsvoks. Brasiliansk voks er hun i gang med å lære seg og vil snart også kunne tilby dette. Lyra er opptatt av detaljer og naturlige, rene resultater som fremhever det beste hos hver enkelt kunde.',
            description3: 'Utenfor salongen er hun en kreativ og glad jente som elsker å synge. Hun har også en liten jentekatt som heter Sienna, som hun er veldig glad i. Lyra er født i 2001 og kommer fra Sunndalsøra, og vi er utrolig glade for å ha henne som en del av Just Peachy-familien.'
          },
          {
            name: 'Thea',
            role: 'Skjønnhetsterapeut',
            description: 'Thea er en erfaren skjønnhetsterapeut som har jobbet freelance i over 4 år med alle behandlingene hun tilbyr. Hun snakker flytende norsk og engelsk, og er kjent for sitt vennlige vesen og øye for detaljer.',
            description2: 'Hos oss tilbyr hun gelenegler, all type kroppsvoks på damer, all type kroppsvoks på menn (utenom manzilian), vanlig vippeløft med InLei, koreansk vippeløft, brynslaminering og HD bryn. Hun er lidenskapelig opptatt av å skape resultater som fremhever din naturlige skjønnhet.',
            description3: 'Utenfor salongen er hun en ekte dyrevenn — hun har selv to hunder og to katter som holder livet hennes både varmt og herlig kaotisk.',
            funfact: '🍑 Funfact: Thea var faktisk kunde nr. 2 i salongen! Vi kjente ikke hverandre fra før, men i løpet av timen kom Kamilla med kommentaren: "Hvem vet, kanskje du jobber her i fremtiden." Og nå gjør hun faktisk det!'
          }
        ],
        traineesTitle: 'Våre Lærlinger',
        trainees: [
          {
            name: 'Nora',
            role: 'Lærling',
            image: 'https://customer-assets.emergentagent.com/job_55b629b9-a9b7-49a4-9b30-4a0fa5a69d68/artifacts/cb1zr0jn_selfie.png',
            description: 'Nora er 19 år og går hudpleie på Årstad vgs. Hun er fra Eivindvik og har også tilknytning til Kvæfjord i Nord-Norge. Hun liker å være med venner og familie, og har en rolig og trygg energi. Favorittbehandlingen hennes er naturlig brynslaminering, og hun er veldig glad i vipper og bryn generelt.',
            funfact: '💛 Funfact: Nora og Kamilla fant ut at de er i slekt, først da praksisperioden startet!'
          }
        ]
      }
    },
    services: {
      tagline: 'Våre Behandlinger',
      title: 'Utvid din',
      titleHighlight: 'indre skjønnhet',
      subtitle: 'Fra naturlig vippeløft som åpner blikket, til perfekt formede bryn og silkemyk hud. Kvalitet som varer!',
      pricesInfo: {
        tagline: 'Priser & Vilkår',
        title: 'Viktig',
        titleHighlight: 'informasjon',
        intro: 'Hos Just Peachy Bergen får du nøye utvalgte behandlinger utført med høyeste faglige standard, trygge kvalitetsprodukter og ekte lidenskap for skjønnhet og velvære. Her finner du en komplett oversikt over våre behandlinger og oppdaterte priser.',
        studentTitle: 'Psst... Vi tilbyr studentrabatt!',
        studentDesc: 'Få 10 % rabatt på alle behandlinger (unntatt pakkepriser) alle hverdager frem til kl. 15:00',
        studentNote: 'Rabatten gjelder kun dersom du selv viser gyldig studentbevis uoppfordret ved oppmøte. Husk å si fra, vi tilbakebetaler ikke mellomlegget dersom du glemmer å opplyse om studentstatus.',
        surchargeTitle: 'Tidstillegg',
        surchargeDesc: 'Vær oppmerksom på at det tilkommer et tillegg for behandlinger på følgende tider:',
        surcharges: [
          'Hverdager etter kl. 18:00: 100 kr',
          'Lørdagstillegg: 150 kr',
          'Søndager/helligdager: 200 kr'
        ],
        surchargeNote: 'Tillegget betales kun én gang per besøk, uansett hvor mange behandlere du har time hos samme dag.',
        cancellationTitle: 'Avbestillingsregler',
        cancellationDesc: 'Ved booking godtar du våre avbestillingsregler.',
        cancellationRules: [
          'Avbestilling senere enn 24 timer før avtalt tid faktureres i sin helhet.',
          'Ved sykdom uten legeerklæring belastes 50 %, og med legeerklæring bortfaller gebyret.'
        ]
      },
      brows: {
        title: 'Bryn',
        description: 'Perfekt formede bryn som fremhever ditt naturlige utseende. Brow lamination, forming, farging og mer.',
        price: 'Fra 350,-',
        cta: 'Se Alle Brynbehandlinger'
      },
      waxing: {
        title: 'Voksing',
        description: 'Profesjonell voksing for ansikt, kropp og intimområde med skånsomme Italwax-produkter. Silkemyk hud!',
        price: 'Fra 200,-',
        cta: 'Se Alle Voksbehandlinger'
      },
      lashLift: {
        title: 'Koreansk Vippeløft',
        description: 'Naturlig vippeløft som åpner blikket og gir deg vakre, bølgende vipper i opptil 8 uker. Ingen extensions!',
        price: 'Fra 890,-',
        cta: 'Les Mer Om Vippeløft'
      },
      facial: {
        title: 'Kurs',
        description: 'Profesjonelle kurs i voksing og brynsbehandlinger for deg som vil lære riktige teknikker og bygge en trygg kundebase. Små grupper og tett oppfølging.',
        price: 'Fra 5 500,-',
        cta: 'Les Mer Om Kurs'
      },
      mainCta: 'Se Alle Priser & Book'
    },
    courses: {
      tagline: 'Bli Ekspert',
      title: 'Lær Profesjonell',
      titleHighlight: 'Voksing',
      description: 'Har du lyst til å lære profesjonelle voksingsteknikker? Hos oss kan du delta på kurs med Kamilla, hvor du får grundig opplæring med kvalitetsprodukter fra Italwax.',
      description2: 'Alle kurs inkluderer teori, praktisk øving, produkter og sertifikat. Du får trygghet og kunnskap til å utføre behandlingene profesjonelt.',
      features: [
        'Ansiktsvoks – lær teknikker for voksing i hele ansiktet',
        'Full Kroppsvoks – ben, armer, rygg og mer',
        'Brasiliansk Voksing – intimvoks for damer',
        'Sertifikat inkludert ved fullført kurs'
      ],
      cta: 'Send Forespørsel',
      interested: 'Interessert? Send en e-post til info@justpeachybergen.no så sender vi deg all informasjon!'
    },
    giftcard: {
      tagline: 'Gi Bort Velvære',
      title: 'Gavekort',
      titleHighlight: 'fra Just Peachy',
      description: 'Gi bort en pause fra hverdagen! Et gavekort fra Just Peachy Bergen er den perfekte gaven til noen du er glad i – eller til deg selv.',
      howItWorks: 'Slik Kjøper Du',
      step1Title: 'Velg Beløp',
      step1Desc: 'Bestem hvor mye du vil gi. Gavekortet kan brukes på alle våre behandlinger.',
      step2Title: 'Betal med Vipps',
      step2Desc: 'Send beløpet til Just Peachy Bergen AS på Vipps.',
      step3Title: 'Få Gavekortet',
      step3Desc: 'Vi sender et pent digitalt gavekort på e-post, eller du kan hente det fysisk i salongen.',
      vippsTitle: 'Betal med Vipps',
      vippsSearch: 'Søk etter: Just Peachy Bergen AS',
      vippsCode: 'Vipps-nummer: #963957',
      vippsNote: 'Husk å skrive ditt navn og e-post i meldingsfeltet!',
      vippsEmailNoticeTitle: 'Viktig etter kjøp',
      vippsEmailNotice: 'Etter kjøp via Vipps ber vi deg sende en e-post til info@justpeachybergen.no og informere om at gavekort er kjøpt. Vi mottar dessverre ikke alltid varsel fra Vipps, og dette sikrer at gavekortet blir opprettet så raskt som mulig.',
      amounts: ['500 kr', '750 kr', '1000 kr', '1500 kr', 'Valgfritt beløp'],
      contact: 'Spørsmål? Kontakt oss på info@justpeachybergen.no',
      cta: 'Åpne Vipps'
    },
    vip: {
      tagline: 'For Våre Lojale Kunder',
      title: 'Just Peachy Bergen',
      titleHighlight: 'Inner Circle',
      subtitle: 'En eksklusiv takk til deg som deler opplevelsen med noen du er glad i.',
      description: 'Når du anbefaler Just Peachy Bergen til en venn, og de booker sin første behandling hos oss, ønsker vi å gi deg en liten eksklusiv oppmerksomhet som takk.',
      howItWorks: 'Slik Fungerer Det',
      steps: [
        {
          title: 'Del Opplevelsen',
          desc: 'Fortell en venn om Just Peachy Bergen og dine erfaringer hos oss.'
        },
        {
          title: 'Vennen Booker',
          desc: 'Din venn booker sin første behandling og skriver i notatfeltet hvem som anbefalte oss (f.eks. "Mari Knutsen anbefalte meg"). Alternativt kan de si det når de kommer til salongen.'
        },
        {
          title: 'Du Får En Gave',
          desc: 'Vi noterer det på din kundeprofil, og neste gang du kommer får du en hyggelig overraskelse!'
        }
      ],
      benefitsTitle: 'Inner Circle Fordeler',
      benefits: [
        'Eksklusiv overraskelse til deg som anbefaler',
        'Prioritert booking ved høy etterspørsel',
        'Tidlig tilgang til nye behandlinger'
      ],
      note: 'Dette er vår måte å si takk på. Ingen koder, ingen stress, bare genuin takknemlighet for at du stoler på oss og deler opplevelsen videre.',
      cta: 'Book Din Neste Time'
    },
    testimonials: {
      tagline: 'Hva Kundene Sier',
      title: 'Ekte',
      titleHighlight: 'Opplevelser',
      reviews: [
        {
          name: 'Ida B.',
          service: 'Koreansk Vippeløft',
          text: 'Det ble så fint resultat! Koselig og fint sted, og hyggelige ansatte. Ble godt tatt vare på, og muligens jeg sovnet under behandlingen 🤭 Kommer tilbake!'
        },
        {
          name: 'Maria S.',
          service: 'Bryn & Voksing',
          text: 'Fantastisk opplevelse fra start til slutt! Kamilla er utrolig dyktig og tar seg god tid. Salongen er så vakker og avslappende. Anbefales!'
        },
        {
          name: 'Line K.',
          service: 'Brasiliansk Voksing',
          text: 'Beste voksing jeg har hatt! Profesjonelt, raskt og nesten smertefritt. Føler meg alltid så velkommen her. 10/10!'
        }
      ]
    },
    beforeAfter: {
      tagline: 'Se Forskjellen',
      title: 'Før &',
      titleHighlight: 'Etter',
      subtitle: 'Oppdag de fantastiske resultatene våre kunder opplever.',
      cta: 'Book Din Behandling',
      items: [
        {
          title: 'Koreansk Vippeløft',
          description: 'Naturlig løft og kurve som varer 6-8 uker'
        },
        {
          title: 'HD Bryn',
          description: 'Perfekt formede bryn tilpasset ditt ansikt'
        },
        {
          title: 'Hybrid Bryn',
          description: 'Kombinasjon av farging og forming for fyldigere bryn'
        },
        {
          title: 'Brynslaminering',
          description: 'Fyldigere, mer definerte bryn'
        },
        {
          title: 'Voksing',
          description: 'Silkemyk hud som varer i uker'
        }
      ]
    },
    instagram: {
      tagline: 'Følg Oss',
      title: 'På Instagram',
      handle: '@justpeachy_bergen',
      cta: 'Følg Oss'
    },
    contact: {
      tagline: 'Si Hei',
      title: 'Besøk Oss',
      titleHighlight: 'i Salongen',
      description: 'Vi gleder oss til å se deg! Salongen ligger lett tilgjengelig i Bergen sentrum, med egen inngang på bakkeplan.',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-post',
      hours: 'Åpningstider',
      hoursWeekday: 'Mandag - Fredag: 08:00 - 20:00',
      hoursWeekend: 'Lørdag - Søndag: 10:00 - 17:00',
      hoursNote: 'Timer kan variere – book online for oppdatert tilgjengelighet',
      parking: 'Parkering: Klostergarasjen (rett rundt hjørnet)',
      bus: 'Buss: Holdeplass Veiten',
      directions: 'Første etasje med egen inngang – ingen trapper!'
    },
    footer: {
      tagline: 'Just Peachy Bergen',
      description: 'Din pause fra hverdagen. Vippeløft, bryn og voksing med en luksuriøs touch i hjertet av Bergen.',
      quickLinks: 'Snarveier',
      followUs: 'Følg Oss',
      contact: 'Kontakt',
      rights: 'Alle rettigheter reservert.',
      madeWith: 'Laget med'
    },
    booking: {
      sticky: 'Book Time'
    },
    lashLiftPage: {
      tagline: 'Vippeløft i Bergen',
      title: 'Koreansk Vippeløft',
      titleHighlight: 'vs. Tradisjonell',
      subtitle: 'Hos Just Peachy Bergen tilbyr vi kun koreansk vippeløft med BOO-teknikken – den mest avanserte metoden for naturlige, vakre vipper.',
      intro: 'Mange kunder lurer på forskjellen mellom tradisjonelt og koreansk vippeløft. Her forklarer vi enkelt hva som skiller dem, slik at du kan ta et informert valg.',
      
      regularTitle: 'Tradisjonelt Vippeløft',
      regularSubtitle: 'Den klassiske metoden',
      regularDesc: 'Tradisjonelt vippeløft bruker en standard silikonpute som presser alle vippene opp i én fast kurve. Metoden har vært populær i mange år, men kan gi et mer kunstig resultat.',
      regularPoints: [
        'Bruker én standardstørrelse silikonpute',
        'Samme kurve for alle vipper – uansett lengde',
        'Kan gi en skarp "L-formet" vinkel',
        'Resultat varer typisk 4-6 uker',
        'Mindre tilpasset dine unike vipper'
      ],
      
      koreanTitle: 'Koreansk Vippeløft',
      koreanSubtitle: 'BOO-teknikken – vår spesialitet',
      koreanDesc: 'Koreansk vippeløft med BOO-teknikk er en nyere, mer avansert metode utviklet i Korea. I stedet for å presse vippene opp i en skarp vinkel, løfter vi dem i en myk, naturlig bue som følger vippenes naturlige vekstretning.',
      koreanPoints: [
        'Skreddersydde silikonstenger tilpasset din vippeform',
        'Myk, naturlig C-kurve – ikke skarp L-form',
        'Vippene ser lengre og fyldigere ut',
        'Resultat varer 6-8 uker',
        'Skånsommere for vippene – bevarer helsen',
        'Ideelt for korte, rette eller nedovervendte vipper'
      ],
      
      whyKorean: 'Hvorfor Vi Kun Tilbyr Koreansk',
      whyKoreanDesc: 'Etter over 10 års erfaring har vi valgt å kun tilby koreansk vippeløft. Her er hvorfor:',
      whyPoints: [
        {
          title: 'Naturlig Resultat',
          desc: 'Vippene får en myk, naturlig kurve som ser ut som du er født med perfekte vipper.'
        },
        {
          title: 'Lenger Holdbarhet',
          desc: 'Resultatet varer 6-8 uker – opptil dobbelt så lenge som tradisjonelt løft.'
        },
        {
          title: 'Skånsom Teknikk',
          desc: 'Metoden er mildere for vippene og bevarer deres naturlige styrke og helse.'
        },
        {
          title: 'Tilpasset Deg',
          desc: 'Vi velger stengstørrelse basert på dine vipper for et optimalt, personlig resultat.'
        }
      ],
      
      suitableTitle: 'Hvem Passer Det For?',
      suitableDesc: 'Koreansk vippeløft passer for nesten alle, og er spesielt bra hvis du:',
      suitablePoints: [
        'Har korte, rette eller nedovervendte vipper',
        'Ønsker et naturlig løft uten extensions',
        'Vil våkne med vakre vipper hver dag',
        'Har sensitive øyne eller bruker linser',
        'Foretrekker lite vedlikehold'
      ],
      notSuitable: 'Ikke anbefalt ved: Aktiv øyeinfeksjon, nylig øyeoperasjon, kjent allergi mot behandlingsprodukter, eller første trimester av graviditet.',
      
      resultsTitle: 'Hva Kan Du Forvente?',
      resultsDesc: 'Etter behandlingen vil du se:',
      resultsPoints: [
        'Umiddelbart synlig løft og åpnere blikk',
        'Vippene ser lengre og fyldigere ut',
        'Naturlig "våknet opp sånn"-look',
        'Ingen behov for vipperuller eller mascara'
      ],
      duration: 'Holdbarhet',
      durationText: '6-8 uker, avhengig av din naturlige vippesyklus',
      treatmentTime: 'Behandlingstid',
      treatmentTimeText: 'Ca. 45-60 minutter – tid til å slappe av',
      
      aftercareTitle: 'Enkel Etterpleie',
      aftercareDesc: 'For best mulig resultat, følg disse enkle rådene:',
      aftercarePoints: [
        'Unngå vann og damp de første 24 timene',
        'Ikke bruk oljebasert makeup-fjerner',
        'Unngå å gni eller dra i vippene',
        'Børst vippene forsiktig med en ren spoolie daglig',
        'Unngå vannfast mascara'
      ],
      
      faqTitle: 'Ofte Stilte Spørsmål',
      faqs: [
        {
          q: 'Gjør behandlingen vondt?',
          a: 'Nei, behandlingen er helt smertefri. Mange kunder sovner faktisk under behandlingen!'
        },
        {
          q: 'Kan jeg bruke mascara etterpå?',
          a: 'Ja, du kan bruke mascara etter 24 timer. Men mange synes de ikke trenger det!'
        },
        {
          q: 'Ødelegger det vippene mine?',
          a: 'Nei, koreansk vippeløft er skånsomt og ødelegger ikke vippene når det utføres riktig.'
        },
        {
          q: 'Hvor ofte kan jeg gjøre det?',
          a: 'Vi anbefaler å vente minst 6-8 uker mellom behandlinger for å la vippene hvile.'
        }
      ],
      
      ctaTitle: 'Klar for Vakre Vipper?',
      ctaDesc: 'Book din time i dag og opplev forskjellen med koreansk vippeløft hos Just Peachy Bergen.',
      ctaButton: 'Book Vippeløft Nå',
      price: 'Fra 890,-'
    },
    booking: {
      tagline: 'Book Time',
      title: 'Book din',
      titleHighlight: 'behandling',
      subtitle: 'Velg en ledig tid som passer for deg. Vi gleder oss til å ta imot deg!'
    },
    faq: {
      tagline: 'Ofte Stilte Spørsmål',
      title: 'Vi har',
      titleHighlight: 'svarene',
      subtitle: 'Finn svar på de vanligste spørsmålene om våre behandlinger. Står ikke svaret her? Ta gjerne kontakt med oss!',
      categories: {
        waxing: 'Voksing',
        lashBrow: 'Vipper & Bryn',
        koreanLash: 'Koreansk Vippeløft',
        brows: 'Bryn',
        booking: 'Timebestilling',
        beforeTreatment: 'Før behandling',
        afterTreatment: 'Etter behandling',
        intimateWax: 'Intimvoks & komfort',
        painComfort: 'Smerte & trygghet',
        comfort: 'Komfort & trygghet',
        hygiene: 'Hygiene & trygghet',
        pregnancy: 'Graviditet',
        firstTime: 'Første gang hos oss',
        courses: 'Kurs',
        trainees: 'Praksiselever',
        reviews: 'Tilbakemeldinger',
        jobs: 'Jobb & samarbeid',
        student: 'Studentrabatt',
        byVenn: 'byVenn',
        parking: 'Parkering & beliggenhet',
        accessibility: 'Tilgjengelighet',
        allergies: 'Allergier & Helse',
        gelNails: 'Gel Negler',
        general: 'Generelt'
      },
      waxing: [
        {
          q: 'Er det veldig vondt å vokse seg?',
          a: 'Smertenivået varierer fra person til person og avhenger av området som vokses. De fleste opplever en kort, håndterbar følelse. Med tiden blir det lettere ettersom hårene blir finere. Vi bruker høykvalitets Italwax som er skånsom mot huden.'
        },
        {
          q: 'Hvilke produkter anbefaler dere om man skal vokse seg?',
          a: 'Vi anbefaler å eksfoliere huden 2-3 dager før behandling for å forhindre inngrodde hår. Etter voksing anbefaler vi en beroligende lotion og å unngå stramme klær. Spør gjerne om produktanbefalinger under behandlingen!'
        },
        {
          q: 'Er det kleint?',
          a: 'Absolutt ikke! Vi er profesjonelle og gjør dette hver dag. Vi skaper en avslappet og komfortabel atmosfære. Du er i trygge hender, og din komfort er vår prioritet.'
        },
        {
          q: 'Er det normalt at kunder roper/banner osv under en voksebehandling?',
          a: 'Ja, det er helt normalt! Alle reagerer forskjellig, og du skal ikke føle deg flau. Vi har sett og hørt det meste, og det påvirker oss ikke i det hele tatt.'
        },
        {
          q: 'Kan jeg vokse brasiliansk når jeg har mensen?',
          a: 'Ja, det kan du! Vi anbefaler å bruke tampong eller menskopp under behandlingen. Vær oppmerksom på at huden kan være mer sensitiv i denne perioden.'
        },
        {
          q: 'Hva bør jeg gjøre før en voksetime?',
          a: 'Hårene bør være ca. 0,5-1 cm lange. Eksfolier huden 2-3 dager før. Unngå solbading og selvbruning rett før behandling. Kom med ren hud uten kremer eller oljer.'
        },
        {
          q: 'Hva bør jeg unngå etter voksing?',
          a: 'Unngå varme bad, sauna, solarium og trening de første 24 timene. Unngå også stramme klær og parfymerte produkter på det voksede området. Eksfolier forsiktig etter noen dager.'
        },
        {
          q: 'Hvor langt må hårene være?',
          a: 'Hårene bør være minst 0,5 cm lange, ideelt rundt 1 cm. Dette tilsvarer ca. 2-3 ukers hårvekst etter barbering.'
        },
        {
          q: 'Hvor lenge bør jeg vente til neste voksetime?',
          a: 'Vi anbefaler å vente 4-6 uker mellom behandlingene. Dette gir hårene tid til å vokse til riktig lengde og sikrer best mulig resultat.'
        },
        {
          q: 'Er det normalt å bli rød etter voksing?',
          a: 'Ja, lett rødhet er helt normalt og forsvinner vanligvis innen noen timer. Noen kan oppleve små røde prikker som går over i løpet av 1-2 dager.'
        },
        {
          q: 'Bruker dere strippsvoks på brasiliansk?',
          a: 'Nei, vi bruker hardvoks (filmvoks) fra Italwax på brasiliansk voksing. Hardvoks fester seg kun til hårene og ikke huden, noe som gjør behandlingen mer skånsom og mindre smertefull.'
        },
        {
          q: 'Kan jeg ta med en venninne eller kjæreste på voksetime?',
          a: 'For å sikre din og andres personvern, tillater vi vanligvis ikke følge under intime behandlinger. For andre behandlinger kan det være OK - bare spør på forhånd!'
        },
        {
          q: 'Er intimbehandlingene diskrete?',
          a: 'Ja 🤍 Vi har fullt fokus på at du skal føle deg trygg, komfortabel og ivaretatt under hele behandlingen.'
        },
        {
          q: 'Hvilke produkter bør jeg bruke etter voksing?',
          a: 'Vi anbefaler produkter som roer huden og forebygger inngrodde hår. Spør oss gjerne i salongen 🤍'
        }
      ],
      lashBrow: [
        {
          q: 'Hva er forskjellen på vanlig vippeløft og koreansk vippeløft?',
          a: 'Koreansk vippeløft (BOO-teknikk) gir en mer naturlig, myk kurve sammenlignet med tradisjonelt løft som kan gi en skarpere L-form. Resultatet varer også lengre (6-8 uker vs 4-6 uker) og er mer skånsomt for vippene.'
        },
        {
          q: 'Hvor lenge varer et vippeløft?',
          a: 'Koreansk vippeløft varer vanligvis 6-8 uker, avhengig av din naturlige vippesyklus. Tradisjonelt vippeløft varer typisk 4-6 uker.'
        },
        {
          q: 'Kan jeg bruke mascara etter vippeløft?',
          a: 'Ja! Vent 24 timer etter behandlingen, så kan du bruke mascara som vanlig. Mange synes de ikke trenger mascara i det hele tatt etter et vippeløft!'
        },
        {
          q: 'Gjør vippeløft vondt?',
          a: 'Nei, behandlingen er helt smertefri. Mange kunder sovner faktisk under behandlingen fordi det er så avslappende!'
        },
        {
          q: 'Hva er brynslaminering?',
          a: 'Brynslaminering er en behandling som retter og løfter brynhårene for å gi et fyldigere, mer definert utseende. Resultatet varer i ca. 6-8 uker.'
        },
        {
          q: 'Hva er HD bryn?',
          a: 'HD bryn er en teknikk hvor vi former brynene perfekt med voks, pinsett og farging for å skape et naturlig, men definert look tilpasset din ansiktsform.'
        },
        {
          q: 'Kan jeg farge brynene selv etterpå?',
          a: 'Vi anbefaler å vente minst 2 uker før du farger brynene igjen. Kommer du til oss, sørger vi for at fargen holder lenge!'
        },
        {
          q: 'Når kan jeg ta vippeløft og brynslaminering igjen?',
          a: 'Lash Filler Vippeløft kan som regel gjøres på nytt etter 4 uker, men vi anbefaler helst å vente 4–6 uker for best mulig resultat. Koreansk Vippeløft kan holde alt fra 6-12 uker. Brow Bomber Brynslaminering bør man vente minst 6-8 uker med, for at hårene skal få tid til å bygge seg opp igjen. Et alternativ på bryn er at du etter 4 uker booker en oppfølgingstime for enten HD Bryn eller Hybrid Bryn, så holder vi brynene fine og definerte frem til neste laminering.'
        },
        {
          q: 'Hva er forskjellen på HD-bryn, hybrid og brow lamination?',
          a: 'HD Bryn: Form og farge tilpasset deg. Hybrid: Mer intens og langvarig farge som setter seg på huden. Brow lamination: Brynene børstes og formes til et fyldigere uttrykk.'
        },
        {
          q: 'Jeg har lite brynshår, hva anbefaler dere?',
          a: 'Vi kan tilpasse både farge og form slik at brynene virker fyldigere og mer balanserte til ansiktet ditt. Ofte anbefaler vi Brow Bomber Brynslaminering kombinert med hybridfarge for å skape ekstra volum og dybde. Mange med lite brynshår har likevel lange hår, og det er nettopp disse vi utnytter og former for å få det til å se ut som om man har større og mer markerte bryn.'
        },
        {
          q: 'Kan jeg dusje rett etter vippeløft-behandling?',
          a: 'Nei, du bør vente med å dusje i minst 24 timer etter vippeløft. Det gjelder også damp, trening, sauna og alt som gir fuktighet til området. Hvis du dusjer for tidlig, kan det påvirke resultatet og gjøre at løftet slipper fortere eller ikke setter seg ordentlig. Etter 24 timer kan du vaske ansiktet og dusje som normalt igjen, men unngå vannfast mascara og bruk helst oljefrie produkter rundt øynene for å bevare resultatet lengst mulig.'
        },
        {
          q: 'Må jeg gjøre noe spesielt før et vippeløft?',
          a: 'Kom med rene vipper, uten mascara eller oljer. Ikke bruk vippeserum samme dag. Vi renser vippene før behandlingen uansett.'
        }
      ],
      booking: [
        {
          q: 'Hvordan booker jeg time?',
          a: 'Du kan enkelt booke time via vår online booking på Timma. Klikk på "Book Time" knappen hvor som helst på nettsiden, så kommer du rett til bookingsiden vår.'
        },
        {
          q: 'Kan jeg avbestille eller endre timen min?',
          a: 'Ja, du kan avbestille eller endre timen din opptil 24 timer før avtalt tid uten kostnad. Ved senere avbestilling eller no-show kan det påløpe et gebyr.'
        },
        {
          q: 'Slik avbestiller du timen din',
          a: 'Du kan enkelt avbestille eller endre timen selv via lenken du fikk i bookingbekreftelsen på e-post. Åpne bekreftelsen, klikk lenken og velg "Avbestill". Finner du ikke bekreftelsen? Send oss en e-post på info@justpeachybergen.no så sender vi den på nytt og dobbeltsjekker at vi har riktig e-postadresse registrert på deg. Husk å avbestille senest 24 timer før timen for å unngå gebyr 🤍'
        },
        {
          q: 'Hva er avbestillingsreglene deres?',
          a: 'Timer må avbestilles eller flyttes senest 24 timer før. Ved sen avbestilling eller uteblivelse belastes timen i sin helhet.'
        },
        {
          q: 'Hva skjer hvis jeg kommer for sent?',
          a: 'Vi anbefaler å komme 5 minutter før avtalt tid. Ved forsinkelse kan behandlingstiden bli forkortet for å ikke påvirke andre kunder. Ved betydelig forsinkelse kan timen bli kansellert.'
        },
        {
          q: 'Tilbyr dere gavekort?',
          a: 'Ja! Vi selger gavekort i valgfritt beløp. Du kan kjøpe via Vipps til Just Peachy Bergen AS (Vipps #963957) og vi sender et digitalt gavekort til deg eller mottakeren.'
        },
        {
          q: 'Hvilke betalingsmetoder godtar dere?',
          a: 'Vi tar kortbetaling og Vipps i salongen. Gavekort kan selvfølgelig også brukes!'
        },
        {
          q: 'Hva hvis det ikke er ledige timer?',
          a: 'Send oss en melding 🤍 Vi prøver alltid å finne en løsning hvis vi kan.'
        },
        {
          q: 'Kan jeg stå på venteliste?',
          a: 'Ja. Du kan sette deg på venteliste dersom ønsket tidspunkt ikke er ledig. Vi kontakter deg dersom noe blir tilgjengelig.'
        },
        {
          q: 'Kan jeg kontakte dere hvis jeg er usikker på hvilken behandling jeg skal velge?',
          a: 'Ja, selvfølgelig. Ta kontakt med oss, så hjelper vi deg å finne riktig behandling.'
        }
      ],
      koreanLash: [
        {
          q: 'Hvor lenge varer Koreansk Vippeløft?',
          a: 'Vanligvis varer resultatet i ca. 6–8 uker, avhengig av dine naturlige vipper og etterpleie.'
        },
        {
          q: 'Skader vippeløft mine naturlige vipper?',
          a: 'Nei, behandlingen utføres skånsomt og profesjonelt med produkter av høy kvalitet.'
        },
        {
          q: 'Kan jeg bruke mascara etter behandlingen?',
          a: 'Ja, men vi anbefaler å vente det første døgnet.'
        },
        {
          q: 'Jeg har rette vipper. Fungerer behandlingen på meg?',
          a: 'Ja, ofte gir behandlingen ekstra fin effekt på rette eller nedovervoksende vipper.'
        },
        {
          q: 'Jeg har klaustrofobi eller synes det er ubehagelig å ha øynene lukket. Kan jeg fortsatt ta Koreansk Vippeløft?',
          a: 'Ja, absolutt. Vi har hjulpet flere kunder som kjenner på dette, og vi tilpasser behandlingen etter dine behov. Gi oss gjerne beskjed på forhånd, så setter vi av god tid og sørger for en rolig opplevelse. Vi er til stede med deg gjennom hele behandlingen, prater om du ønsker det, og guider deg trygt gjennom hvert steg. Dersom du trenger pauser eller ønsker å åpne øynene underveis på bestemte tidspunkt, tilpasser vi oss selvfølgelig dette.'
        }
      ],
      brows: [
        {
          q: 'Hvilken brynsbehandling passer meg?',
          a: 'Vi hjelper deg gjerne å velge behandling basert på ansiktsform, hudtone, hårvekst og ønsket resultat.'
        },
        {
          q: 'Hvor lenge varer hybridfarge?',
          a: 'Hybridfarge varer ofte opptil 7–10 dager på huden og lenger på hårstråene.'
        }
      ],
      comfort: [
        {
          q: 'Jeg gruer meg litt før behandling. Hva gjør jeg?',
          a: 'Det er helt normalt å være spent. Vi tar oss god tid, forklarer underveis og sørger for at du føler deg trygg.'
        },
        {
          q: 'Kan jeg komme alene selv om jeg er nervøs?',
          a: 'Ja, selvfølgelig. Mange kunder kommer alene, og vi tar godt vare på deg.'
        }
      ],
      parking: [
        {
          q: 'Er det parkering i nærheten av salongen?',
          a: 'Vi har dessverre ikke egen parkering rett utenfor salongen, men det finnes gode alternativer svært nærme. Nærmeste og ofte mest praktiske valg er Klostergarasjen. Dersom du parkerer der, velger du utgang mot Torgallmenningen. Når du kommer ut, ligger salongen rett rundt hjørnet til venstre. Et annet alternativ er CityPark, som ligger ca to minutters gange unna salongen.'
        }
      ],
      byVenn: [
        {
          q: 'Er Just Peachy Bergen med i byVenn?',
          a: 'Ja, vi er med i byVenn og deltar jevnlig i kampanjer og tilbud for medlemmer.'
        },
        {
          q: 'Tar dere betaling via byVenn?',
          a: 'Ja, dersom kampanjen gjelder betaling eller kupong via byVenn følger vi vilkårene oppgitt i appen.'
        },
        {
          q: 'Har dere kampanjer som kun gjelder via byVenn?',
          a: 'Ja, enkelte kampanjer og tilbud er eksklusive for byVenn-medlemmer og er kun tilgjengelige gjennom byVenn i kampanjeperioden.'
        },
        {
          q: 'Kan jeg booke et byVenn-tilbud utenfor kampanjeperioden og få samme pris?',
          a: 'Nei. byVenn-tilbud gjelder kun innen oppgitt kampanjeperiode og på vilkårene som står i kampanjen.'
        },
        {
          q: 'Må jeg vise noe for å bruke byVenn-tilbud?',
          a: 'Ja. Gyldig byVenn-kupong i appen må vises ved oppmøte eller betaling. Enkelte kampanjer krever også aktivering i appen.'
        },
        {
          q: 'Godtar dere screenshots av byVenn-kuponger?',
          a: 'Nei. Kupongen må vises live i appen ved oppmøte eller betaling.'
        },
        {
          q: 'Har dere egne byVenn-timer i booking?',
          a: 'Ja. Vi har en egen byVenn-kategori i bookingsystemet vårt. Alle behandlinger som inngår i aktive byVenn-kampanjer skal bookes gjennom denne kategorien for at tilbudet skal gjelde.'
        },
        {
          q: 'Hvordan booker jeg en byVenn-kampanje?',
          a: 'Når du ønsker å benytte en aktiv byVenn-kampanje, velger du vår byVenn-kategori i bookingkalenderen og booker behandlingen der.'
        },
        {
          q: 'Kan jeg booke vanlig time og bruke byVenn-rabatt etterpå?',
          a: 'Nei. byVenn-kampanjer må bookes gjennom vår byVenn-kategori mens kampanjen er aktiv.'
        },
        {
          q: 'Gjelder byVenn-tilbud alle behandlinger?',
          a: 'Nei. Hvert tilbud gjelder kun behandlingene som er spesifisert i kampanjen.'
        },
        {
          q: 'Kan byVenn-tilbud kombineres med andre rabatter?',
          a: 'Som hovedregel kan byVenn-tilbud ikke kombineres med andre rabatter eller kampanjer, med mindre annet er oppgitt.'
        },
        {
          q: 'Hvor finner jeg nye byVenn-kampanjer fra dere?',
          a: 'I byVenn-appen og i våre sosiale medier når vi lanserer nye kampanjer.'
        }
      ],
      beforeTreatment: [
        {
          q: 'Hvor langt må håret være før voksing?',
          a: 'Håret bør være ca. 0,5–1 cm langt (tilsvarer ca. 2–3 uker med vekst) for best resultat.'
        },
        {
          q: 'Kan jeg barbere meg før timen?',
          a: 'Vi anbefaler å ikke barbere området rett før, da håret kan bli for kort til å få et godt resultat.'
        },
        {
          q: 'Kan jeg ta behandling under mensen?',
          a: 'Ja, det går helt fint 🤍 Vi anbefaler å bruke tampong, og vær obs på at huden kan være litt mer sensitiv i denne perioden.'
        },
        {
          q: 'Bør jeg dusje før timen?',
          a: 'Ja, det er alltid en fordel å komme nyvasket før behandling 🤍'
        },
        {
          q: 'Kan jeg trene før timen?',
          a: 'Ja, men unngå å komme svett rett til behandling. Dusj gjerne først for best komfort og hygiene.'
        }
      ],
      afterTreatment: [
        {
          q: 'Hva bør jeg unngå etter voksing?',
          a: 'Unngå trening, badstue, soling og stramme klær i 24 timer etter behandling.'
        },
        {
          q: 'Hvor lenge varer resultatet?',
          a: 'De fleste opplever glatte resultater i 3–4 uker, avhengig av hårvekst.'
        },
        {
          q: 'Når bør jeg booke neste time?',
          a: 'Vi anbefaler hver 4.–5. uke for best resultat over tid.'
        },
        {
          q: 'Hvordan unngår jeg inngrodde hår?',
          a: 'Bruk milde skrubber og fuktighetsprodukter jevnlig. Vi hjelper deg gjerne med anbefalinger 🤍'
        }
      ],
      intimateWax: [
        {
          q: 'Får jeg noe før brasiliansk voks?',
          a: 'Ja 🤍 Du får alltid en intimserviett før behandlingen slik at du kan friske deg opp.'
        },
        {
          q: 'Hva er inkludert i brasiliansk voks?',
          a: 'Brasiliansk voks inkluderer alt av hårfjerning i intimområdet, både foran og bak.'
        },
        {
          q: 'Kan jeg velge å ikke vokse bak?',
          a: 'Ja, selvfølgelig. Du bestemmer alltid selv hva du ønsker.'
        },
        {
          q: 'Kan jeg vokse bak hvis jeg har hemoroider?',
          a: 'Ja, men vi vokser aldri over området. Vi er ekstra forsiktige og jobber rundt. Du kan også velge å droppe bak helt 🤍'
        },
        {
          q: 'Må jeg ta av alt undertøy?',
          a: 'Du får veiledning underveis, og vi tilpasser alltid etter hva du er komfortabel med.'
        },
        {
          q: 'Hva hvis jeg er nervøs?',
          a: 'Det er helt normalt 🤍 Vi guider deg gjennom hele behandlingen og sørger for at du føler deg trygg.'
        },
        {
          q: 'Er intimbehandlingene diskrete?',
          a: 'Ja 🤍 Vi har fullt fokus på at du skal føle deg trygg, komfortabel og ivaretatt under hele behandlingen.'
        }
      ],
      painComfort: [
        {
          q: 'Gjør det vondt med voksing?',
          a: 'Det kan være litt ubehagelig, spesielt første gang, men det går raskt over. De fleste opplever at det blir mye mindre vondt etter noen behandlinger.'
        },
        {
          q: 'Har dere tips for mindre smerte?',
          a: 'Ja! Unngå koffein før timen, pust rolig, og kom regelmessig – det gjør stor forskjell.'
        }
      ],
      hygiene: [
        {
          q: 'Hvordan jobber dere med hygiene?',
          a: 'Vi følger strenge hygienerutiner og bruker kun profesjonelle produkter av høy kvalitet.'
        },
        {
          q: 'Bruker dere hansker under behandling?',
          a: 'Ja, alltid 🤍'
        }
      ],
      student: [
        {
          q: 'Har dere studentrabatt?',
          a: 'Ja! Vi tilbyr 10% studentrabatt på alle behandlinger på hverdager frem til kl. 15:00. Rabatten gjelder ikke pakkepriser.'
        },
        {
          q: 'Hvordan får jeg studentrabatt?',
          a: 'Vis gyldig studentbevis ved betaling. Rabatten trekkes fra automatisk. Husk at dette kun gjelder hverdager før kl. 15:00.'
        },
        {
          q: 'Gjelder studentrabatten på alle behandlinger?',
          a: 'Studentrabatten gjelder på enkeltbehandlinger, men ikke på pakkepriser eller gavekort. Den gjelder heller ikke i kombinasjon med andre tilbud.'
        },
        {
          q: 'Gjelder studentrabatt på produktene dere selger i salongen?',
          a: 'Nei, dessverre. Studentrabatt gjelder kun på behandlinger hos oss. Når det gjelder produkter vi selger i salongen, så har de samme pris for absolutt alle.'
        },
        {
          q: 'Gjelder studentrabatten hver gang jeg kommer?',
          a: 'Studentrabatt er gyldig helt frem til studentbeviset er gått ut på dato.'
        },
        {
          q: 'Jeg glemte å si fra at jeg er student og har allerede betalt. Kan jeg få tilbake det jeg betalte ekstra?',
          a: 'Dessverre, så gjør vi ikke tilbakebetalinger i etterkant av behandling. Det er kundens ansvar å si fra og vise gyldig studentbevis før betaling i kassen. Vi spør ikke automatisk om noen er student, så for å sikre deg rabatten din, må du selv gi beskjed i forkant.'
        }
      ],
      accessibility: [
        {
          q: 'Jeg er blind, kan jeg komme på time?',
          a: 'Ja, selvfølgelig! Alle er hjertelig velkommen hos oss, og vi ønsker aldri å ekskludere noen. Vi har hatt flere kunder opp gjennom årene som er blinde eller har nedsatt syn, og vi tilrettelegger alltid etter behov. Når du kommer, forklarer vi alt tydelig – hvordan rommet ser ut, hva som skjer underveis i behandlingen og hva du kan forvente. Vi er veldig opptatt av å gi deg en trygg og klar beskrivelse, slik at du kan slappe av og føle deg komfortabel gjennom hele opplevelsen. Dersom du trenger hjelp med noe, som for eksempel ledsaging inn, bestilling eller ringing av taxi, så hjelper vi gjerne. Ved inngangen har vi en liten kant/minitrapp på noen få centimeter. De fleste rullestoler kommer fint over denne, men si gjerne ifra på forhånd dersom du ønsker assistanse. Det er dessverre trapper ned til toalettet – gi oss beskjed før timen dersom dette er viktig for deg, så finner vi den beste løsningen sammen. Det er bare å sende oss en melding før timen, så ordner vi det du trenger.'
        },
        {
          q: 'Hva er aldersgrensen for å ta behandling hos dere?',
          a: 'Aldersgrensen hos oss er 18 år på alle behandlinger. Men! Er du under 18, kan du fortsatt få behandling, så lenge vi har fått en skriftlig bekreftelse fra en foresatt som sier at de vet om det og syns det er greit. Vi gjør det for å passe på deg, og for å være trygge på at alt er i orden hjemme også. 💖'
        }
      ],
      allergies: [
        {
          q: 'Jeg har nøtteallergi. Kan jeg ta behandlingen?',
          a: 'Ja, det kan du, så lenge du gir beskjed før vi starter behandlingen. Selv om vi noterer allergier i profilen din, må du alltid si ifra hver eneste gang du kommer. Vi vil aldri risikere at det går fort i svingene og at vi glemmer det og bruker produkter som inneholder nøtter. Gi beskjed uansett hvilken behandling du skal ta, så tilrettelegger vi trygt for deg. Det eneste vi trenger å gjøre, er som regel å bytte ut enkelte produkter.'
        },
        {
          q: 'Jeg bruker Iso. Kan jeg vokse i ansiktet?',
          a: 'Nei. Hvis du går på Isotretinoin (f.eks. Roaccutan/Curacne), må du informere oss om det før vi starter behandlingen. Som regel gjelder det bare ansiktsområdet, der huden er ekstra sensitiv, at voksing ikke er trygt. Du bør vente minst 1-2 måneder etter avsluttet kur før du vokser ansiktet, da huden trenger tid til å styrke seg igjen. Vokser man ansiktet mens man går på Iso, risikerer man å rive av hud og få kraftige reaksjoner. Hvis du fortsatt er på kur, kan vi heller nappe hårene forsiktig som et trygt alternativ.'
        },
        {
          q: 'Jeg bruker retinol i ansiktet. Kan jeg vokse?',
          a: 'Både ja og nei. Det kommer an på flere ting, som hvor i ansiktet du bruker retinol, hvor sterk den er, og hvor ofte du bruker den. Retinol gjør huden tynnere og mer sensitiv, og det kan føre til at man drar med seg det øverste hudlaget ved voksing. Som regel går det helt fint, så lenge du sier ifra før behandlingen starter. Da vurderer vi huden din sammen, og tar gjerne en liten test på et lite område først. Dersom du er usikker eller huden virker sår, velger vi heller å nappe hårene forsiktig. Vi anbefaler også at det helst har gått minst én uke siden du sist brukte retinol. Si alltid ifra før vi starter, så vurderer vi hva som er trygt og best for akkurat deg.'
        },
        {
          q: 'Tilbyr dere konsultasjon eller allergitest?',
          a: 'Ja! Begge behandlingene er gratis hos oss. Vi setter av ca 15-20 minutter til å se om du reagerer på produktene, ha konsultasjon og eventuelt booke time.'
        },
        {
          q: 'Kan jeg ta behandling hvis jeg går på medisiner eller har sensitiv hud?',
          a: 'Gi oss beskjed på forhånd 🤍 Enkelte medisiner og hudtilstander kan påvirke huden, så vi vurderer sammen hva som er trygt for deg.'
        }
      ],
      pregnancy: [
        {
          q: 'Kan jeg ta behandlinger når jeg er gravid?',
          a: 'Ja 🤍 De fleste behandlingene våre kan trygt utføres under graviditet. Kroppen kan være litt mer sensitiv, så vi tilpasser alltid etter deg og hva som føles komfortabelt.'
        },
        {
          q: 'Kan jeg ta voksing når jeg er gravid?',
          a: 'Ja, voksing er helt trygt under graviditet. Noen opplever litt mer sensitiv hud, men vi jobber skånsomt og tilpasser underveis.'
        },
        {
          q: 'Kan jeg ta brasiliansk voks som gravid?',
          a: 'Ja, så lenge du føler deg komfortabel. Vi har god erfaring med gravide kunder og tilrettelegger behandlingen slik at du ligger behagelig hele veien.'
        },
        {
          q: 'Er det trygt å ta vippeløft hvis man er gravid?',
          a: 'Ja, men vi har noen retningslinjer: Vi utfører ikke vippeløft på gravide i første trimester (de første 12 ukene), da kroppen gjennomgår store hormonelle endringer. Etter første trimester kan vi gjennomføre behandlingen, men vi ber deg sende en e-post til oss før timen med bekreftelse på at du tar behandlingen på eget ansvar. Vær oppmerksom på at hormonelle endringer under graviditeten kan påvirke resultatet av vippeløftet. Gi oss beskjed på forhånd, så vurderer vi sammen hva som er tryggest.'
        },
        {
          q: 'Påvirker graviditet resultatet av behandlingene?',
          a: 'Hormonelle endringer under graviditeten kan påvirke både hud og hårvekst. Noen opplever at vippeløft eller brynslaminering ikke holder like lenge, mens andre ikke merker forskjell. Vi informerer alltid om dette før behandlingen.'
        },
        {
          q: 'Kan jeg ligge slik jeg vil under behandling?',
          a: 'Selvfølgelig. Du kan ligge på siden, ta pauser eller justere underveis – vi tilpasser oss deg 🤍'
        },
        {
          q: 'Tilrettelegger dere for gravide kunder?',
          a: 'Ja! Vi gjør alltid det vi kan for at du skal føle deg trygg og komfortabel under hele behandlingen.'
        },
        {
          q: 'Er det noe jeg bør tenke på som gravid før behandling?',
          a: 'Det viktigste er å lytte til kroppen din 🤍 Gi oss gjerne beskjed dersom du er ekstra sensitiv eller har behov for pauser, så tilpasser vi behandlingen deretter.'
        },
        {
          q: 'Hva hvis jeg blir svimmel, dårlig eller trenger pause under behandlingen?',
          a: 'Det er helt ok 🤍 Si ifra med en gang. Hvis du for eksempel må lukke øynene eller føler deg uvel, så stopper vi opp, hjelper deg rolig ned og gir deg tid til å hente deg inn igjen.'
        },
        {
          q: 'Hva hvis jeg må på toalettet under behandlingen?',
          a: 'Det går helt fint 🤍 Bare si ifra. Hvis du for eksempel er i en behandling hvor du må ha øynene lukket (som vippeløft), så hjelper vi deg og guider deg trygt til toalettet. Vi tilpasser alltid behandlingen etter deg og sørger for at du føler deg komfortabel hele veien 🤍'
        }
      ],
      firstTime: [
        {
          q: 'Hva kan jeg forvente første gang?',
          a: 'Du blir tatt godt imot og guidet gjennom hele behandlingen. Vi forklarer underveis og tilpasser etter deg.'
        },
        {
          q: 'Hva hvis jeg er usikker eller har spørsmål?',
          a: 'Spør oss! Vi er her for å hjelpe deg og gjøre opplevelsen så trygg og behagelig som mulig 🤍'
        }
      ],
      courses: [
        {
          q: 'Hvor holdes kursene?',
          a: 'Alle kurs holdes i salongen vår i Veiten 2B, Bergen sentrum 🤍'
        },
        {
          q: 'Kan du komme til oss og holde kurs?',
          a: 'Ja! Jeg kan reise til dere, også til f.eks. Nord-Norge. Dette må avtales på forhånd, og pris justeres etter reise, fly, hotell og opphold.'
        },
        {
          q: 'Hvor lenge varer et kurs?',
          a: 'Kursene varer ca. én arbeidsdag (5–7 timer), avhengig av type kurs.'
        },
        {
          q: 'Hva er inkludert i kurset?',
          a: 'Teori og praktisk opplæring, jobbing på modell, diplom etter fullført kurs, lunsj 🤍 og oppfølging i ettertid.'
        },
        {
          q: 'Får man oppfølging etter kurset?',
          a: 'Ja 🤍 Du blir lagt til i en eksklusiv gruppe med tidligere elever, hvor jeg deler tips og teknikker, favorittprodukter, nyheter, anbefalinger og ekstra læring. Du kan også alltid ta kontakt om du trenger hjelp etter kurset.'
        },
        {
          q: 'Kan jeg ta med egen modell?',
          a: 'Ja, det kan du 🤍 Hvis ikke kan vi hjelpe med modell ved behov.'
        },
        {
          q: 'Når må jeg betale for kurset?',
          a: 'Hele kursavgiften må betales før kursdato. Plassen din er sikret når betalingen er gjennomført.'
        },
        {
          q: 'Har dere pakkepris på flere kurs eller flere deltakere?',
          a: 'Per nå tilbyr vi ikke pakkepris, alle kurs prises per person.'
        },
        {
          q: 'Kan jeg ta kurset online?',
          a: 'Jeg jobber aktivt med å lage online kurs 🤍 Teoridelen vil snart kunne tas digitalt og gi et teoridiplom. For best mulig læring anbefaler vi likevel fysisk kurs i salongen for å øve på teknikk og jobbe på modell.'
        },
        {
          q: 'Bruker dere spesifikke produkter på kurs?',
          a: 'Ja, alle kurs holdes med produkter fra Italwax.'
        },
        {
          q: 'Får man goodiebag på kurs?',
          a: 'Jeg jobber med dette 🤍 I fremtiden vil alle kurs inkludere goodiebag, og jeg kommer også til å sende ut til tidligere elever som ikke fikk.'
        },
        {
          q: 'Har dere toalett i salongen?',
          a: 'Ja 🤍'
        },
        {
          q: 'Får vi lunsj under kurset?',
          a: 'Ja, lunsj er inkludert.'
        },
        {
          q: 'Må jeg ha erfaring fra før?',
          a: 'Nei 🤍 Kursene passer både for nybegynnere og de som ønsker å utvikle seg videre.'
        },
        {
          q: 'Får jeg diplom etter kurset?',
          a: 'Ja, du får diplom fra Just Peachy Bergen etter fullført kurs.'
        },
        {
          q: 'Kan jeg jobbe med dette etter kurset?',
          a: 'Ja! Kurset gir deg et godt grunnlag for å jobbe med behandlingene, men det er viktig å øve videre for å bli trygg og rask.'
        },
        {
          q: 'Hva gjør kursene dine annerledes?',
          a: 'Hos oss får du ikke bare et kurs, du får ekte oppfølging, ærlige tips og teknikker som faktisk fungerer i salong.'
        }
      ],
      trainees: [
        {
          q: 'Hva er praksisbehandlinger?',
          a: 'Dette er behandlinger utført av elever i praksis hos oss, under tett oppfølging.'
        },
        {
          q: 'Er kvaliteten like bra?',
          a: 'Ja, vi bruker samme produkter og teknikker som vanlig. Alt blir kvalitetssikret underveis.'
        }
      ],
      reviews: [
        {
          q: 'Hva hvis jeg ikke er fornøyd?',
          a: 'Si ifra 🤍 Vi setter stor pris på tilbakemeldinger – det er slik vi kan bli bedre og rette opp. Det eneste vi ber om er at tilbakemeldingen gis på en fin måte. Vi er mennesker vi også, og vi ønsker alltid å hjelpe deg uansett.'
        },
        {
          q: 'Hvor kan jeg legge igjen en anmeldelse?',
          a: 'Du kan legge igjen review på Google eller Timma – vi blir såå glade og sjekker det hele tiden 😭🤍'
        },
        {
          q: 'Hva hvis jeg ønsker å gi en negativ review?',
          a: 'Ta gjerne kontakt med oss først. Vi vil alltid gjøre vårt beste for å finne en løsning du blir fornøyd med.'
        }
      ],
      jobs: [
        {
          q: 'Hvordan søker jeg jobb hos dere?',
          a: 'Send en mail til info@justpeachybergen.no med emne "Jobbsøknad" 🤍'
        },
        {
          q: 'Må jeg ha erfaring for å jobbe hos dere?',
          a: 'Nei. Det viktigste for oss er hvem du er som person. For meg (Kamilla) er det viktigst at du er hyggelig, positiv, en god kollega og bidrar til godt arbeidsmiljø. Alt av behandlinger kan læres 🤍 Men hvordan man er som person kan ikke læres på samme måte. Jeg er veldig nøye på hvem som får jobbe hos oss, fordi det er viktig for meg at både jeg og teamet trives og gleder oss til å komme på jobb.'
        }
      ],
      gelNails: [
        {
          q: 'Hvorfor får jeg ikke til å booke Fjerning av negler?',
          a: 'Dette er fordi Thea er allergisk mot en type gele som mange salonger bruker. For å hindre at kunder kommer med negler Thea ikke kan jobbe med pga. allergien, ønsker vi at du tar kontakt med oss for å booke akkurat den behandlingen. På den måten kan vi sammen sikre at du har negler som Thea tåler å jobbe med 🤍 Send oss gjerne en e-post til info@justpeachybergen.no eller en DM på Instagram @justpeachy_bergen, så hjelper vi deg med å booke.'
        },
        {
          q: 'Hvordan booker jeg time hos Thea for gelenegler?',
          a: 'Nye gelenegler eller påfyll booker du enkelt via bookingsystemet vårt. For fjerning av gamle negler (påført et annet sted) må du ta kontakt med oss først — det er slik at vi kan sikre at gelen på neglene dine ikke er en type Thea er allergisk mot. Skriv til oss på info@justpeachybergen.no eller Instagram, og fortell hvilken salong du sist var hos hvis du husker det. Så finner vi tid til deg 💅'
        },
        {
          q: 'Hvilken type gele bruker Thea?',
          a: 'Thea bruker en høykvalitets gele som hun selv tåler godt, og som gir et pent og holdbart resultat. Hun holder seg unna typer gele som utløser hennes allergi, og er derfor forsiktig med hvilke negler hun fjerner eller jobber over — særlig hvis du har fått påført negler et annet sted vi ikke kjenner produktet fra.'
        },
        {
          q: 'Kan jeg få fylt på negler jeg fikk lagt et annet sted?',
          a: 'Vi anbefaler at du tar kontakt før du booker påfyll av negler laget et annet sted, slik at vi kan avklare produktet. I mange tilfeller vil vi anbefale full fjerning og nytt sett, både av hensyn til Thea sin allergi og for at resultatet skal bli så pent og holdbart som mulig 🤍'
        }
      ],
      general: [
        {
          q: 'Jeg har booket time, men har ikke fått noen e-post med bookingbekreftelse, hva gjør jeg?',
          a: 'Først og fremst: sjekk søppelpost/spam-mappen i e-posten din. Noen ganger havner bekreftelsen der. Dersom du fortsatt ikke finner noe, kan du sende oss en melding på Instagram eller e-post med fullt navn, tlf nr og e-postadressen du brukte ved bestilling. Da sjekker vi profilen din i systemet vårt og ser om det for eksempel er en skrivefeil i e-postadressen, retter det opp og sender deg bookingbekreftelsen på nytt.'
        },
        {
          q: 'Kan jeg flytte timen min selv?',
          a: 'Ikke helt! Du må sende oss en melding hvis du ønsker å endre tidspunkt eller behandling. Vi hjelper deg gjerne! Du kan sende oss en DM på Instagram eller en e-post med fullt navn og tidspunktet du ønsker å endre, så fikser vi det.'
        },
        {
          q: 'Jeg har vært hos en annen salong og fått et mislykket resultat. Kan jeg ta ny behandling hos dere?',
          a: 'Ja, det kan du! Men vi anbefaler at du kommer innom på en kort konsultasjon først, slik at vi kan se på vippene dine og vurdere om de tåler en ny behandling med en gang. Vi er vant til å jobbe med både reklamasjoner og mer krevende vipper, og har god erfaring med å rette opp i vanskelige resultat fra andre salonger.'
        },
        {
          q: 'Selger dere produkter?',
          a: 'Ja, vi har nøye utvalgte produkter for etterbehandling 🤍'
        },
        {
          q: 'Kan jeg kjøpe gavekort?',
          a: 'Ja! Perfekt gave 🎁 Du kan kjøpe via Vipps til Just Peachy Bergen AS (Vipps #963957).'
        }
      ],
      ctaTitle: 'Fant du ikke svaret du lette etter?',
      ctaDesc: 'Ta gjerne kontakt med oss, så hjelper vi deg!',
      ctaButton: 'Kontakt Oss'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      courses: 'Courses',
      giftcard: 'Gift Card',
      faq: 'FAQ',
      booking: 'Book Online',
      contact: 'Contact',
      book: 'Book Now'
    },
    waitlist: {
      button: 'No available times? Join our waitlist',
      noTimesText: 'No times that suit you? Join our waitlist – we often get cancellations.',
      title: 'Join the Waitlist',
      subtitle: 'Fill out the form and we\'ll contact you when something becomes available.',
      form: {
        name: 'Full name',
        namePlaceholder: 'Your name',
        phone: 'Phone number',
        phonePlaceholder: '+47 XXX XX XXX',
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        treatment: 'Desired treatment',
        treatmentPlaceholder: 'Select treatment',
        treatments: {
          brazilianWax: 'Brazilian wax',
          bikiniWax: 'Bikini wax',
          fullLegs: 'Full legs',
          halfLegs: 'Half legs',
          underarms: 'Underarms',
          arms: 'Arms',
          faceWax: 'Face wax',
          koreanLashLift: 'Korean Lash Lift',
          lashFiller: 'Lash Filler Lift',
          browLamination: 'Brow lamination',
          hdBrows: 'HD Brows',
          hybridTint: 'Hybrid brow tint',
          gelNails: 'Gel Nails',
          facialTreatment: 'Facial treatment',
          other: 'Other'
        },
        staff: 'Preferred staff',
        staffPlaceholder: 'Select staff (optional)',
        staffOptions: {
          noPreference: 'No preference',
          kamilla: 'Kamilla',
          thea: 'Thea',
          lyra: 'Lyra',
          nora: 'Nora'
        },
        preferredDays: 'Preferred days',
        days: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday'
        },
        preferredTimes: 'Preferred times',
        times: {
          morning: 'Morning (09-12)',
          afternoon: 'Afternoon (12-15)',
          evening: 'Evening (15-18)'
        },
        shortNotice: 'Can you come on short notice?',
        shortNoticeYes: 'Yes, please call me',
        shortNoticeNo: 'No, I need more time',
        notes: 'Other wishes or comments',
        notesPlaceholder: 'Write here if you have special requests...',
        submit: 'Join waitlist',
        submitting: 'Sending...'
      },
      success: {
        title: 'Thank you! 🍑',
        message: 'We\'ll contact you if something becomes available.',
        close: 'Close',
        shareTitle: 'Know someone else waiting for an appointment?',
        shareSubtitle: 'Share the waitlist – we often get cancellations on short notice.',
        shareWhatsapp: 'Share on WhatsApp',
        shareSms: 'Send as SMS',
        shareCopy: 'Copy link',
        shareCopied: 'Link copied!',
        shareMessage: 'Hi! Just Peachy Bergen has a waitlist for openings – they often get last-minute cancellations. Join here:'
      },
      homepage: {
        tagline: 'Fully booked?',
        title: 'Join our',
        titleHighlight: 'waitlist',
        description: 'We often get cancellations on short notice. Leave your information and we\'ll contact you when something becomes available.',
        cta: 'Join the waitlist'
      }
    },
    hero: {
      tagline: 'Your Break from Everyday Life',
      title: 'Welcome to',
      titleHighlight: 'Just Peachy Bergen',
      subtitle: 'Beauty, wellness and a little extra self-care.',
      subtitleLine2: 'Experience a salon where every treatment is tailored for you.',
      cta: 'Book Your Appointment',
      scrollText: 'Discover more'
    },
    about: {
      tagline: 'Who We Are',
      title: 'Meet Kamilla',
      titleHighlight: '& The Team',
      description: 'At Just Peachy Bergen, it\'s about more than just treatments – it\'s about how you feel when you leave. A place where you can be yourself, take a break and just be.',
      description2: 'With over 10 years of experience and thousands of happy clients, we combine high expertise, certified techniques and a warm, safe atmosphere. Here you can relax with a cup of coffee while we take care of you.',
      description3: 'The salon is located at Veiten 2B, right in Bergen city center, with its own entrance at ground level. Easy to access with no stairs!',
      experience: 'Years Experience',
      clients: 'Clients Yearly',
      treatments: 'Treatments',
      cta: 'Book With Us',
      video: {
        tagline: 'Get To Know Us',
        title: 'A little glimpse into',
        titleHighlight: 'our everyday',
        description: 'Here you can get to know me and the salon a little better. I was interviewed about my journey, what drives me, and what Just Peachy Bergen means to me. Hope you enjoy it!'
      },
      team: {
        title: 'Meet The Team',
        owner: {
          name: 'Kamilla',
          role: 'Owner and founder',
          description: 'I was born in 1997 and come from a small village in Northern Norway called Kvæfjord. I have worked in the beauty industry since I was 17, and have loved it since the very beginning. For me, this is not just about treatments, but about people. Many of my clients have followed me for over ten years, and the relationships we build mean incredibly much.',
          description2: 'One of my biggest driving forces is to make waxing less intimidating. I want to turn something many dread into a safe and positive experience. My dream is to create a salon where everyone feels welcome, cared for, and enjoys it so much they almost do not want to leave.',
          description3: 'I have renovated the salon myself with great help from Lyra and my boyfriend Kristian, and do everything from website and social media to accounting and development on my own. There is a lot of love behind every single detail.',
          description4: 'In my free time I like to sing, be creative and make small projects myself. I have a cat named Stella who means a lot to me.',
          description5: 'I speak both Norwegian and English fluently, and warmly welcome you to Just Peachy Bergen 🤍'
        },
        staffTitle: 'Our Team',
        staff: [
          {
            name: 'Lyra',
            role: 'Beauty Therapist',
            description: 'Lyra has worked at Just Peachy Bergen since September 2025 and has quickly become an important part of the team. She is meticulous, calm and dedicated to making all clients feel safe and well cared for during treatments. Lyra speaks fluent Norwegian and English.',
            description2: 'She offers Korean lash lift, HD brows, hybrid brows, brow lamination, facial wax and full body wax. She is currently learning Brazilian wax and will soon be able to offer this as well. Lyra is focused on details and natural, clean results that bring out the best in each client.',
            description3: 'Outside the salon, she is a creative and happy girl who loves to sing. She also has a little female cat named Sienna, whom she loves dearly. Lyra was born in 2001 and comes from Sunndalsøra, and we are incredibly happy to have her as part of the Just Peachy family.'
          },
          {
            name: 'Thea',
            role: 'Beauty Therapist',
            description: 'Thea is an experienced beauty therapist who has worked freelance for over 4 years across all the treatments she offers. She speaks fluent Norwegian and English, and is known for her warm personality and eye for detail.',
            description2: 'With us she offers gel nails, all types of body waxing for women, all types of body waxing for men (except manzilian), classic lash lift with InLei, Korean lash lift, brow lamination and HD brows. She is passionate about creating results that enhance your natural beauty.',
            description3: 'Outside the salon she is a true animal lover — she has two dogs and two cats of her own who keep her life warm and lovingly chaotic.',
            funfact: '🍑 Fun fact: Thea was actually customer number 2 in the salon! We did not know each other before, but during her appointment Kamilla made the comment: "Who knows, maybe you will work here one day." And now she actually does!'
          }
        ],
        traineesTitle: 'Our Trainees',
        trainees: [
          {
            name: 'Nora',
            role: 'Trainee',
            image: 'https://customer-assets.emergentagent.com/job_55b629b9-a9b7-49a4-9b30-4a0fa5a69d68/artifacts/cb1zr0jn_selfie.png',
            description: 'Nora is 19 years old and studies skincare at Årstad vgs. She is from Eivindvik and also has connections to Kvæfjord in Northern Norway. She enjoys spending time with friends and family, and has a calm and reassuring energy. Her favorite treatment is natural brow lamination, and she loves lashes and brows.',
            funfact: '💛 Fun fact: Nora and Kamilla discovered they are related when her internship started!'
          }
        ]
      }
    },
    services: {
      tagline: 'Our Services',
      title: 'Expand your',
      titleHighlight: 'inner beauty',
      subtitle: 'From natural lash lift that opens up your eyes, to perfectly shaped brows and silky smooth skin. Quality that lasts!',
      pricesInfo: {
        tagline: 'Prices & Terms',
        title: 'Important',
        titleHighlight: 'information',
        intro: 'At Just Peachy Bergen you get carefully selected treatments performed with the highest professional standard, safe quality products and genuine passion for beauty and wellness. Here you will find a complete overview of our treatments and updated prices.',
        studentTitle: 'Psst... We offer student discount!',
        studentDesc: 'Get 10% off all treatments (except package prices) on weekdays until 3:00 PM',
        studentNote: 'The discount only applies if you show valid student ID unprompted upon arrival. Remember to mention it, we do not refund the difference if you forget to inform us of your student status.',
        surchargeTitle: 'Time surcharges',
        surchargeDesc: 'Please note that a surcharge applies for treatments at the following times:',
        surcharges: [
          'Weekdays after 6:00 PM: 100 kr',
          'Saturdays: 150 kr',
          'Sundays/holidays: 200 kr'
        ],
        surchargeNote: 'The surcharge is only paid once per visit, regardless of how many therapists you have appointments with on the same day.',
        cancellationTitle: 'Cancellation policy',
        cancellationDesc: 'By booking you accept our cancellation policy.',
        cancellationRules: [
          'Cancellation later than 24 hours before the scheduled time will be charged in full.',
          'In case of illness without a doctors note, 50% is charged, and with a doctors note the fee is waived.'
        ]
      },
      brows: {
        title: 'Brows',
        description: 'Perfectly shaped brows that enhance your natural look. Brow lamination, shaping, tinting and more.',
        price: 'From 350,-',
        cta: 'See All Brow Treatments'
      },
      waxing: {
        title: 'Waxing',
        description: 'Professional waxing for face, body and intimate areas with gentle Italwax products. Silky smooth skin!',
        price: 'From 200,-',
        cta: 'See All Waxing Treatments'
      },
      lashLift: {
        title: 'Korean Lash Lift',
        description: 'Natural lash lift that opens up your eyes and gives you beautiful, curled lashes for up to 8 weeks. No extensions!',
        price: 'From 890,-',
        cta: 'Learn More About Lash Lift'
      },
      facial: {
        title: 'Courses',
        description: 'Professional courses in waxing and brow treatments for those who want to learn the right techniques and build a confident client base. Small groups and close follow-up.',
        price: 'From 5 500,-',
        cta: 'Learn More About Courses'
      },
      mainCta: 'See All Prices & Book'
    },
    courses: {
      tagline: 'Become an Expert',
      title: 'Learn Professional',
      titleHighlight: 'Waxing',
      description: 'Want to learn professional waxing techniques? Join our courses with Kamilla, where you\'ll receive thorough training using Italwax quality products.',
      description2: 'All courses include theory, practical training, products and certificate. You\'ll gain confidence and knowledge to perform treatments professionally.',
      features: [
        'Facial Waxing – learn techniques for waxing the entire face',
        'Full Body Waxing – legs, arms, back and more',
        'Brazilian Waxing – intimate waxing for women',
        'Certificate included upon completion'
      ],
      cta: 'Send Inquiry',
      interested: 'Interested? Send an email to info@justpeachybergen.no and we\'ll send you all the information!'
    },
    giftcard: {
      tagline: 'Give the Gift of Wellness',
      title: 'Gift Card',
      titleHighlight: 'from Just Peachy',
      description: 'Give someone a break from everyday life! A gift card from Just Peachy Bergen is the perfect gift for someone you love – or for yourself.',
      howItWorks: 'How It Works',
      step1Title: 'Choose Amount',
      step1Desc: 'Decide how much you want to give. The gift card can be used for all our treatments.',
      step2Title: 'Pay with Vipps',
      step2Desc: 'Send the amount to Just Peachy Bergen AS on Vipps.',
      step3Title: 'Get Your Gift Card',
      step3Desc: 'We\'ll send a beautiful digital gift card by email, or you can pick it up at the salon.',
      vippsTitle: 'Pay with Vipps',
      vippsSearch: 'Search for: Just Peachy Bergen AS',
      vippsCode: 'Vipps number: #963957',
      vippsNote: 'Remember to write your name and email in the message field!',
      vippsEmailNoticeTitle: 'Important after purchase',
      vippsEmailNotice: 'After paying with Vipps, please send an email to info@justpeachybergen.no letting us know that a gift card has been purchased. We unfortunately do not always receive notifications from Vipps, and this ensures the gift card is created as quickly as possible.',
      amounts: ['500 kr', '750 kr', '1000 kr', '1500 kr', 'Custom amount'],
      contact: 'Questions? Contact us at info@justpeachybergen.no',
      cta: 'Open Vipps'
    },
    vip: {
      tagline: 'For Our Loyal Clients',
      title: 'Just Peachy Bergen',
      titleHighlight: 'Inner Circle',
      subtitle: 'An exclusive thank you to those who share the experience with someone they care about.',
      description: 'When you recommend Just Peachy Bergen to a friend, and they book their first treatment with us, we want to give you a small exclusive gesture of appreciation.',
      howItWorks: 'How It Works',
      steps: [
        {
          title: 'Share the Experience',
          desc: 'Tell a friend about Just Peachy Bergen and your experiences with us.'
        },
        {
          title: 'Friend Books',
          desc: 'Your friend books their first treatment and writes in the appointment notes who recommended us (e.g. "Mari Knutsen recommended me"). Alternatively, they can tell us at the salon.'
        },
        {
          title: 'You Get a Gift',
          desc: 'We note it on your customer profile, and next time you visit you\'ll receive a nice surprise!'
        }
      ],
      benefitsTitle: 'Inner Circle Benefits',
      benefits: [
        'Exclusive surprise for you who recommended',
        'Priority booking during high demand',
        'Early access to new treatments'
      ],
      note: 'This is our way of saying thank you. No codes, no fuss – just genuine gratitude for trusting us and sharing the experience.',
      cta: 'Book Your Next Visit'
    },
    testimonials: {
      tagline: 'What Clients Say',
      title: 'Real',
      titleHighlight: 'Experiences',
      reviews: [
        {
          name: 'Ida B.',
          service: 'Korean Lash Lift',
          text: 'The results were amazing! Lovely and beautiful place with friendly staff. I was well taken care of, and I might have fallen asleep during the treatment 🤭 Will definitely be back!'
        },
        {
          name: 'Maria S.',
          service: 'Brows & Waxing',
          text: 'Fantastic experience from start to finish! Kamilla is incredibly skilled and takes her time. The salon is so beautiful and relaxing. Highly recommend!'
        },
        {
          name: 'Line K.',
          service: 'Brazilian Waxing',
          text: 'Best waxing I\'ve ever had! Professional, fast and almost painless. I always feel so welcome here. 10/10!'
        }
      ]
    },
    beforeAfter: {
      tagline: 'See the Difference',
      title: 'Before &',
      titleHighlight: 'After',
      subtitle: 'Discover the amazing results our clients experience.',
      cta: 'Book Your Treatment',
      items: [
        {
          title: 'Korean Lash Lift',
          description: 'Natural lift and curve that lasts 6-8 weeks'
        },
        {
          title: 'HD Brows',
          description: 'Perfectly shaped brows tailored to your face'
        },
        {
          title: 'Hybrid Brows',
          description: 'Combination of tinting and shaping for fuller brows'
        },
        {
          title: 'Brow Lamination',
          description: 'Fuller, more defined brows'
        },
        {
          title: 'Waxing',
          description: 'Silky smooth skin that lasts for weeks'
        }
      ]
    },
    instagram: {
      tagline: 'Follow Us',
      title: 'On Instagram',
      handle: '@justpeachy_bergen',
      cta: 'Follow Us'
    },
    contact: {
      tagline: 'Say Hello',
      title: 'Visit Us',
      titleHighlight: 'at the Salon',
      description: 'We look forward to seeing you! The salon is easily accessible in Bergen city center, with its own entrance at ground level.',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      hours: 'Opening Hours',
      hoursWeekday: 'Monday - Friday: 08:00 - 20:00',
      hoursWeekend: 'Saturday - Sunday: 10:00 - 17:00',
      hoursNote: 'Hours may vary – book online for current availability',
      parking: 'Parking: Klostergarasjen (right around the corner)',
      bus: 'Bus: Veiten stop',
      directions: 'Ground floor with own entrance – no stairs!'
    },
    footer: {
      tagline: 'Just Peachy Bergen',
      description: 'Your break from everyday life. Lash lift, brows and waxing with a luxurious touch in the heart of Bergen.',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      contact: 'Contact',
      rights: 'All rights reserved.',
      madeWith: 'Made with'
    },
    booking: {
      sticky: 'Book Now'
    },
    lashLiftPage: {
      tagline: 'Lash Lift in Bergen',
      title: 'Korean Lash Lift',
      titleHighlight: 'vs. Traditional',
      subtitle: 'Understand the difference and choose the right treatment for you. We use the advanced BOO technique for natural, beautiful results.',
      intro: 'Many clients ask us about the difference between regular lash lift and Korean lash lift. Here we explain everything you need to know to make the best choice for your lashes.',
      
      regularTitle: 'Traditional Lash Lift',
      regularSubtitle: 'The classic method',
      regularDesc: 'Traditional lash lift has been popular for many years. The treatment lifts the lashes from the root and gives a more open look.',
      regularPoints: [
        'Uses a standard silicone pad',
        'One fixed curve for all lashes',
        'Results last 4-6 weeks',
        'Can create an "L-shaped" curve',
        'Less customized to individual lashes'
      ],
      
      koreanTitle: 'Korean Lash Lift',
      koreanSubtitle: 'BOO technique – the advanced method',
      koreanDesc: 'Korean lash lift with BOO technique is a newer, more advanced method that gives a more natural and tailored result. This is the treatment we offer at Just Peachy Bergen.',
      koreanPoints: [
        'Customized silicone rods for your lash shape',
        'Natural, wavy curve – not L-shaped',
        'Results last 6-8 weeks',
        'Gentle treatment that preserves lash health',
        'Creates the illusion of longer lashes',
        'Perfect for short or straight lashes'
      ],
      
      whyKorean: 'Why We Choose Korean',
      whyKoreanDesc: 'At Just Peachy Bergen, we only use Korean lash lift with the BOO technique. Here\'s why:',
      whyPoints: [
        {
          title: 'Natural result',
          desc: 'Gives a soft, natural curve that looks like your own lashes – just better.'
        },
        {
          title: 'Longer lasting',
          desc: 'Results last up to 8 weeks, compared to 4-6 weeks for traditional lift.'
        },
        {
          title: 'Gentle treatment',
          desc: 'The technique is gentler and preserves the structure and health of lashes.'
        },
        {
          title: 'Customized for you',
          desc: 'We choose rod size based on your lash shape for optimal results.'
        }
      ],
      
      suitableTitle: 'Who Is It For?',
      suitableDesc: 'Korean lash lift suits most people, and is especially good for you if you:',
      suitablePoints: [
        'Have short or straight lashes',
        'Want a natural lift without extensions',
        'Want a "woke up like this" look',
        'Have sensitive eyes',
        'Are looking for low maintenance'
      ],
      notSuitable: 'Not recommended if you have: Eye infection, recent eye surgery, allergy to treatment products, or are in the first trimester of pregnancy.',
      
      resultsTitle: 'Results & Duration',
      resultsDesc: 'After treatment you will experience:',
      resultsPoints: [
        'Immediately visible lift and curve',
        'Lashes appear longer',
        'More open and awake look',
        'Natural look without mascara'
      ],
      duration: 'Duration',
      durationText: '6-8 weeks depending on your natural lash cycle',
      treatmentTime: 'Treatment Time',
      treatmentTimeText: 'Approx. 45-60 minutes',
      
      aftercareTitle: 'Aftercare',
      aftercareDesc: 'For the best results, follow these tips:',
      aftercarePoints: [
        'Avoid water and steam for the first 24 hours',
        'Do not use oil-based makeup remover',
        'Avoid rubbing or pulling on lashes',
        'Brush lashes gently with a clean spoolie daily',
        'Avoid waterproof mascara'
      ],
      
      faqTitle: 'Frequently Asked Questions',
      faqs: [
        {
          q: 'Does the treatment hurt?',
          a: 'No, the treatment is completely painless. Many clients actually fall asleep during treatment!'
        },
        {
          q: 'Can I wear mascara afterwards?',
          a: 'Yes, you can use mascara after 24 hours. But many find they don\'t need it!'
        },
        {
          q: 'Does it damage my lashes?',
          a: 'No, Korean lash lift is gentle and does not damage lashes when performed correctly.'
        },
        {
          q: 'How often can I do it?',
          a: 'We recommend waiting at least 6-8 weeks between treatments to let lashes rest.'
        }
      ],
      
      ctaTitle: 'Ready for Beautiful Lashes?',
      ctaDesc: 'Book your appointment today and experience the difference with Korean lash lift at Just Peachy Bergen.',
      ctaButton: 'Book Lash Lift Now',
      price: 'From 890,-'
    },
    booking: {
      tagline: 'Book Appointment',
      title: 'Book your',
      titleHighlight: 'treatment',
      subtitle: 'Choose an available time that suits you. We look forward to welcoming you!'
    },
    faq: {
      tagline: 'Frequently Asked Questions',
      title: 'We have',
      titleHighlight: 'the answers',
      subtitle: 'Find answers to the most common questions about our treatments. Can\'t find what you\'re looking for? Feel free to contact us!',
      categories: {
        waxing: 'Waxing',
        lashBrow: 'Lashes & Brows',
        koreanLash: 'Korean Lash Lift',
        brows: 'Brows',
        booking: 'Booking',
        beforeTreatment: 'Before Treatment',
        afterTreatment: 'After Treatment',
        intimateWax: 'Intimate Wax & Comfort',
        painComfort: 'Pain & Comfort',
        comfort: 'Comfort & Safety',
        hygiene: 'Hygiene & Safety',
        pregnancy: 'Pregnancy',
        firstTime: 'First Time With Us',
        courses: 'Courses',
        trainees: 'Trainees',
        reviews: 'Feedback',
        jobs: 'Jobs & Collaboration',
        student: 'Student Discount',
        byVenn: 'byVenn',
        parking: 'Parking & Location',
        accessibility: 'Accessibility',
        allergies: 'Allergies & Health',
        gelNails: 'Gel Nails',
        general: 'General'
      },
      waxing: [
        {
          q: 'Is waxing very painful?',
          a: 'Pain levels vary from person to person and depend on the area being waxed. Most people experience a brief, manageable sensation. Over time it gets easier as the hair becomes finer. We use high-quality Italwax that is gentle on the skin.'
        },
        {
          q: 'What products do you recommend for waxing?',
          a: 'We recommend exfoliating the skin 2-3 days before treatment to prevent ingrown hairs. After waxing, we recommend a soothing lotion and avoiding tight clothing. Feel free to ask for product recommendations during your treatment!'
        },
        {
          q: 'Is it awkward?',
          a: 'Absolutely not! We are professionals and do this every day. We create a relaxed and comfortable atmosphere. You are in safe hands, and your comfort is our priority.'
        },
        {
          q: 'Is it normal for clients to scream during a waxing treatment?',
          a: 'Yes, it\'s completely normal! Everyone reacts differently, and you shouldn\'t feel embarrassed. We\'ve seen and heard it all, and it doesn\'t affect us at all.'
        },
        {
          q: 'Can I get a Brazilian wax during my period?',
          a: 'Yes, you can! We recommend using a tampon or menstrual cup during the treatment. Be aware that your skin may be more sensitive during this time.'
        },
        {
          q: 'What should I do before a waxing appointment?',
          a: 'Hair should be about 0.5-1 cm long. Exfoliate the skin 2-3 days before. Avoid sunbathing and self-tanning right before treatment. Come with clean skin without creams or oils.'
        },
        {
          q: 'What should I avoid after waxing?',
          a: 'Avoid hot baths, sauna, tanning beds and exercise for the first 24 hours. Also avoid tight clothing and perfumed products on the waxed area. Exfoliate gently after a few days.'
        },
        {
          q: 'How long does the hair need to be?',
          a: 'Hair should be at least 0.5 cm long, ideally around 1 cm. This equals about 2-3 weeks of hair growth after shaving.'
        },
        {
          q: 'How long should I wait until my next waxing appointment?',
          a: 'We recommend waiting 4-6 weeks between treatments. This gives the hair time to grow to the right length and ensures the best possible result.'
        },
        {
          q: 'Is it normal to get red after waxing?',
          a: 'Yes, slight redness is completely normal and usually disappears within a few hours. Some may experience small red dots that go away within 1-2 days.'
        },
        {
          q: 'Do you use strip wax for Brazilian?',
          a: 'No, we use hard wax (film wax) from Italwax for Brazilian waxing. Hard wax only adheres to the hair and not the skin, making the treatment gentler and less painful.'
        },
        {
          q: 'Can I bring a friend or partner to my waxing appointment?',
          a: 'To ensure your privacy and that of others, we usually don\'t allow companions during intimate treatments. For other treatments it may be OK - just ask in advance!'
        },
        {
          q: 'Are intimate treatments discreet?',
          a: 'Yes 🤍 We fully focus on making you feel safe, comfortable and cared for throughout the entire treatment.'
        },
        {
          q: 'What products should I use after waxing?',
          a: 'We recommend products that soothe the skin and prevent ingrown hairs. Feel free to ask us at the salon 🤍'
        }
      ],
      lashBrow: [
        {
          q: 'What is the difference between regular and Korean lash lift?',
          a: 'Korean lash lift (BOO technique) gives a more natural, soft curve compared to traditional lift which can give a sharper L-shape. The result also lasts longer (6-8 weeks vs 4-6 weeks) and is gentler on the lashes.'
        },
        {
          q: 'How long does a lash lift last?',
          a: 'Korean lash lift usually lasts 6-8 weeks, depending on your natural lash cycle. Traditional lash lift typically lasts 4-6 weeks.'
        },
        {
          q: 'Can I use mascara after a lash lift?',
          a: 'Yes! Wait 24 hours after the treatment, then you can use mascara as normal. Many find they don\'t need mascara at all after a lash lift!'
        },
        {
          q: 'Does lash lift hurt?',
          a: 'No, the treatment is completely painless. Many clients actually fall asleep during the treatment because it\'s so relaxing!'
        },
        {
          q: 'What is brow lamination?',
          a: 'Brow lamination is a treatment that straightens and lifts brow hairs to give a fuller, more defined appearance. The result lasts for about 6-8 weeks.'
        },
        {
          q: 'What are HD brows?',
          a: 'HD brows is a technique where we shape the brows perfectly with wax, tweezers and tinting to create a natural but defined look tailored to your face shape.'
        },
        {
          q: 'Can I tint my brows myself afterwards?',
          a: 'We recommend waiting at least 2 weeks before tinting your brows again. If you come to us, we ensure the color lasts long!'
        },
        {
          q: 'When can I have lash lift and brow lamination again?',
          a: 'Lash Filler Lash Lift can usually be done again after 4 weeks, but we recommend waiting 4-6 weeks for best results. Korean Lash Lift can last 6-12 weeks. Brow Bomber Brow Lamination should wait at least 6-8 weeks to let the hairs build up again. An alternative for brows is to book a follow-up for HD Brows or Hybrid Brows after 4 weeks to keep your brows defined until the next lamination.'
        },
        {
          q: 'What is the difference between HD brows, hybrid and brow lamination?',
          a: 'HD Brows: Shape and color tailored to you. Hybrid: More intense and long-lasting color that sets on the skin. Brow lamination: Brows are brushed and shaped for a fuller expression.'
        },
        {
          q: 'I have sparse brow hair, what do you recommend?',
          a: 'We can adjust both color and shape so that the brows appear fuller and more balanced to your face. We often recommend Brow Bomber Brow Lamination combined with hybrid color to create extra volume and depth. Many with sparse brow hair still have long hairs, and it\'s these we utilize and shape to make it look like you have larger and more defined brows.'
        },
        {
          q: 'Can I shower right after lash lift treatment?',
          a: 'No, you should wait at least 24 hours after lash lift before showering. This also applies to steam, exercise, sauna and anything that brings moisture to the area. If you shower too early, it can affect the result. After 24 hours you can wash your face and shower normally again, but avoid waterproof mascara and preferably use oil-free products around the eyes to preserve the result as long as possible.'
        },
        {
          q: 'Do I need to do anything special before a lash lift?',
          a: 'Come with clean lashes, without mascara or oils. Don\'t use lash serum the same day. We clean the lashes before the treatment anyway.'
        }
      ],
      booking: [
        {
          q: 'How do I book an appointment?',
          a: 'You can easily book an appointment through our online booking on Timma. Click the "Book Now" button anywhere on the website and you\'ll go straight to our booking page.'
        },
        {
          q: 'Can I cancel or change my appointment?',
          a: 'Yes, you can cancel or change your appointment up to 24 hours before the scheduled time at no cost. Late cancellations or no-shows may incur a fee.'
        },
        {
          q: 'How to cancel your appointment',
          a: 'You can easily cancel or change your appointment yourself via the link in the booking confirmation email you received. Open the confirmation, click the link and select "Cancel". Can\'t find the confirmation? Send us an email at info@justpeachybergen.no and we\'ll resend it and double-check that we have the correct email address registered for you. Remember to cancel at least 24 hours in advance to avoid a fee 🤍'
        },
        {
          q: 'What are your cancellation policies?',
          a: 'Appointments must be cancelled or rescheduled at least 24 hours in advance. Late cancellations or no-shows will be charged in full.'
        },
        {
          q: 'What happens if I\'m late?',
          a: 'We recommend arriving 5 minutes before your scheduled time. If you\'re late, the treatment time may be shortened to not affect other customers. Significant delays may result in cancellation.'
        },
        {
          q: 'Do you offer gift cards?',
          a: 'Yes! We sell gift cards in any amount. You can buy via Vipps to Just Peachy Bergen AS (Vipps #963957) and we\'ll send a digital gift card to you or the recipient.'
        },
        {
          q: 'What payment methods do you accept?',
          a: 'We accept card and Vipps at the salon. Gift cards can of course also be used!'
        },
        {
          q: 'What if there are no available appointments?',
          a: 'Send us a message 🤍 We always try to find a solution if we can.'
        },
        {
          q: 'Can I be on a waiting list?',
          a: 'Yes. You can put yourself on a waiting list if your preferred time is not available. We\'ll contact you if something becomes available.'
        },
        {
          q: 'Can I contact you if I\'m unsure which treatment to choose?',
          a: 'Yes, of course. Contact us and we\'ll help you find the right treatment.'
        }
      ],
      koreanLash: [
        {
          q: 'How long does Korean Lash Lift last?',
          a: 'Results typically last about 6–8 weeks, depending on your natural lashes and aftercare.'
        },
        {
          q: 'Does lash lift damage my natural lashes?',
          a: 'No, the treatment is performed gently and professionally with high-quality products.'
        },
        {
          q: 'Can I use mascara after the treatment?',
          a: 'Yes, but we recommend waiting the first 24 hours.'
        },
        {
          q: 'I have straight lashes. Does the treatment work for me?',
          a: 'Yes, the treatment often gives extra beautiful results on straight or downward-growing lashes.'
        },
        {
          q: 'I have claustrophobia or find it uncomfortable to keep my eyes closed. Can I still have Korean Lash Lift?',
          a: 'Yes, absolutely. We\'ve helped many clients who experience this, and we adapt the treatment to your needs. Let us know in advance, and we\'ll set aside extra time and ensure a calm experience. We\'re with you throughout the entire treatment, chat if you wish, and guide you safely through each step. If you need breaks or want to open your eyes at certain points, we\'ll adapt accordingly.'
        }
      ],
      brows: [
        {
          q: 'Which brow treatment suits me?',
          a: 'We\'re happy to help you choose a treatment based on face shape, skin tone, hair growth and desired result.'
        },
        {
          q: 'How long does hybrid tint last?',
          a: 'Hybrid tint often lasts up to 7–10 days on the skin and longer on the hair strands.'
        }
      ],
      comfort: [
        {
          q: 'I\'m a bit nervous before treatment. What do I do?',
          a: 'It\'s completely normal to be excited. We take our time, explain along the way and make sure you feel safe.'
        },
        {
          q: 'Can I come alone even if I\'m nervous?',
          a: 'Yes, of course. Many clients come alone, and we take good care of you.'
        }
      ],
      parking: [
        {
          q: 'Is there parking near the salon?',
          a: 'Unfortunately we don\'t have our own parking right outside the salon, but there are good alternatives very close by. The nearest and often most practical option is Klostergarasjen. If you park there, choose the exit towards Torgallmenningen. When you come out, the salon is right around the corner to the left. Another option is CityPark, which is about two minutes walk from the salon.'
        }
      ],
      byVenn: [
        {
          q: 'Is Just Peachy Bergen part of byVenn?',
          a: 'Yes, we\'re part of byVenn and regularly participate in campaigns and offers for members.'
        },
        {
          q: 'Do you accept payment via byVenn?',
          a: 'Yes, if the campaign involves payment or coupon via byVenn, we follow the terms stated in the app.'
        },
        {
          q: 'Do you have campaigns that only apply via byVenn?',
          a: 'Yes, some campaigns and offers are exclusive to byVenn members and are only available through byVenn during the campaign period.'
        },
        {
          q: 'Can I book a byVenn offer outside the campaign period and get the same price?',
          a: 'No. byVenn offers only apply within the specified campaign period and on the terms stated in the campaign.'
        },
        {
          q: 'Do I need to show anything to use byVenn offers?',
          a: 'Yes. A valid byVenn coupon in the app must be shown upon arrival or payment. Some campaigns also require activation in the app.'
        },
        {
          q: 'Do you accept screenshots of byVenn coupons?',
          a: 'No. The coupon must be shown live in the app upon arrival or payment.'
        },
        {
          q: 'Do you have separate byVenn slots in booking?',
          a: 'Yes. We have a separate byVenn category in our booking system. All treatments included in active byVenn campaigns must be booked through this category for the offer to apply.'
        },
        {
          q: 'How do I book a byVenn campaign?',
          a: 'When you want to use an active byVenn campaign, you select our byVenn category in the booking calendar and book the treatment there.'
        },
        {
          q: 'Can I book a regular appointment and use byVenn discount afterwards?',
          a: 'No. byVenn campaigns must be booked through our byVenn category while the campaign is active.'
        },
        {
          q: 'Do byVenn offers apply to all treatments?',
          a: 'No. Each offer only applies to the treatments specified in the campaign.'
        },
        {
          q: 'Can byVenn offers be combined with other discounts?',
          a: 'As a general rule, byVenn offers cannot be combined with other discounts or campaigns, unless otherwise stated.'
        },
        {
          q: 'Where can I find new byVenn campaigns from you?',
          a: 'In the byVenn app and on our social media when we launch new campaigns.'
        }
      ],
      beforeTreatment: [
        {
          q: 'How long does the hair need to be before waxing?',
          a: 'Hair should be about 0.5–1 cm long (about 2–3 weeks of growth) for best results.'
        },
        {
          q: 'Can I shave before my appointment?',
          a: 'We recommend not shaving the area right before, as the hair may be too short for a good result.'
        },
        {
          q: 'Can I have treatment during my period?',
          a: 'Yes, that\'s perfectly fine 🤍 We recommend using a tampon, and be aware that your skin may be a bit more sensitive during this time.'
        },
        {
          q: 'Should I shower before my appointment?',
          a: 'Yes, it\'s always an advantage to come freshly showered before treatment 🤍'
        },
        {
          q: 'Can I exercise before my appointment?',
          a: 'Yes, but avoid arriving sweaty. Please shower first for best comfort and hygiene.'
        }
      ],
      afterTreatment: [
        {
          q: 'What should I avoid after waxing?',
          a: 'Avoid exercise, sauna, sunbathing and tight clothes for 24 hours after treatment.'
        },
        {
          q: 'How long do results last?',
          a: 'Most people experience smooth results for 3–4 weeks, depending on hair growth.'
        },
        {
          q: 'When should I book my next appointment?',
          a: 'We recommend every 4–5 weeks for best results over time.'
        },
        {
          q: 'How do I avoid ingrown hairs?',
          a: 'Use gentle scrubs and moisturizing products regularly. We\'re happy to help with recommendations 🤍'
        }
      ],
      intimateWax: [
        {
          q: 'Do I get anything before Brazilian wax?',
          a: 'Yes 🤍 You always get an intimate wipe before the treatment so you can freshen up.'
        },
        {
          q: 'What\'s included in Brazilian wax?',
          a: 'Brazilian wax includes all hair removal in the intimate area, both front and back.'
        },
        {
          q: 'Can I choose not to wax the back?',
          a: 'Yes, of course. You always decide what you want.'
        },
        {
          q: 'Can I wax the back if I have hemorrhoids?',
          a: 'Yes, but we never wax over the area. We\'re extra careful and work around it. You can also choose to skip the back entirely 🤍'
        },
        {
          q: 'Do I have to remove all underwear?',
          a: 'You get guidance along the way, and we always adapt to what you\'re comfortable with.'
        },
        {
          q: 'What if I\'m nervous?',
          a: 'That\'s completely normal 🤍 We guide you through the entire treatment and make sure you feel safe.'
        },
        {
          q: 'Are intimate treatments discreet?',
          a: 'Yes 🤍 We fully focus on making you feel safe, comfortable and cared for throughout the entire treatment.'
        }
      ],
      painComfort: [
        {
          q: 'Does waxing hurt?',
          a: 'It can be a bit uncomfortable, especially the first time, but it passes quickly. Most people find it gets much less painful after a few treatments.'
        },
        {
          q: 'Do you have tips for less pain?',
          a: 'Yes! Avoid caffeine before your appointment, breathe calmly, and come regularly – it makes a big difference.'
        }
      ],
      hygiene: [
        {
          q: 'How do you work with hygiene?',
          a: 'We follow strict hygiene routines and only use professional high-quality products.'
        },
        {
          q: 'Do you use gloves during treatment?',
          a: 'Yes, always 🤍'
        }
      ],
      student: [
        {
          q: 'Do you have student discount?',
          a: 'Yes! We offer 10% student discount on all treatments on weekdays until 3:00 PM. The discount does not apply to package prices.'
        },
        {
          q: 'How do I get the student discount?',
          a: 'Show valid student ID at payment. The discount is applied automatically. Remember this only applies on weekdays before 3:00 PM.'
        },
        {
          q: 'Does the student discount apply to all treatments?',
          a: 'The student discount applies to individual treatments, but not to package prices or gift cards. It also cannot be combined with other offers.'
        },
        {
          q: 'Does the student discount apply to products you sell in the salon?',
          a: 'No, unfortunately. Student discount only applies to treatments. Products sold in the salon have the same price for everyone.'
        },
        {
          q: 'Does the student discount apply every time I come?',
          a: 'Student discount is valid as long as your student ID has not expired.'
        },
        {
          q: 'I forgot to mention I\'m a student and have already paid. Can I get a refund?',
          a: 'Unfortunately, we do not make refunds after treatment. It is the customer\'s responsibility to show valid student ID before payment. We don\'t automatically ask if someone is a student, so to ensure your discount, you must let us know in advance.'
        }
      ],
      accessibility: [
        {
          q: 'I am blind, can I come for an appointment?',
          a: 'Yes, of course! Everyone is warmly welcome, and we never want to exclude anyone. We have had several customers over the years who are blind or have impaired vision, and we always accommodate their needs. When you arrive, we explain everything clearly – how the room looks, what happens during the treatment and what to expect. We are committed to giving you a safe and clear description so you can relax and feel comfortable throughout the experience. If you need help with anything, such as guidance in, booking or calling a taxi, we are happy to help. Just send us a message before your appointment and we\'ll arrange what you need.'
        },
        {
          q: 'What is the age limit for treatments?',
          a: 'The age limit is 18 years for all treatments. However, if you are under 18, you can still get treatment as long as we have received written confirmation from a guardian saying they know about it and approve. We do this to take care of you and to make sure everything is in order. 💖'
        }
      ],
      allergies: [
        {
          q: 'I have a nut allergy. Can I have the treatment?',
          a: 'Yes, you can, as long as you let us know before we start the treatment. Even though we note allergies in your profile, you must always let us know every single time you come. We never want to risk using products that contain nuts. Let us know regardless of which treatment you are having, and we will accommodate you safely. Usually all we need to do is replace certain products.'
        },
        {
          q: 'I use Isotretinoin. Can I wax my face?',
          a: 'No. If you are on Isotretinoin (e.g. Roaccutan/Curacne), you must inform us before we start the treatment. Usually it only applies to the face area, where the skin is extra sensitive. You should wait at least 1-2 months after finishing the course before waxing your face, as the skin needs time to strengthen. If you are still on the course, we can gently pluck the hairs as a safe alternative.'
        },
        {
          q: 'I use retinol on my face. Can I wax?',
          a: 'Both yes and no. It depends on several things, such as where on your face you use retinol, how strong it is, and how often you use it. Retinol makes the skin thinner and more sensitive. Usually it\'s fine, as long as you let us know before the treatment starts. We recommend that at least one week has passed since you last used retinol. Always let us know before we start, and we\'ll assess what is safe and best for you.'
        },
        {
          q: 'Do you offer consultation or allergy testing?',
          a: 'Yes! Both are free. We set aside about 15-20 minutes to see if you react to the products, have a consultation and possibly book an appointment.'
        },
        {
          q: 'Can I have treatment if I\'m on medication or have sensitive skin?',
          a: 'Let us know in advance 🤍 Some medications and skin conditions can affect the skin, so we\'ll assess together what is safe for you.'
        }
      ],
      pregnancy: [
        {
          q: 'Can I have treatments while pregnant?',
          a: 'Yes 🤍 Most of our treatments can be safely performed during pregnancy. Your body may be a bit more sensitive, so we always adapt to you and what feels comfortable.'
        },
        {
          q: 'Can I have waxing while pregnant?',
          a: 'Yes, waxing is completely safe during pregnancy. Some experience slightly more sensitive skin, but we work gently and adapt as we go.'
        },
        {
          q: 'Can I have Brazilian wax while pregnant?',
          a: 'Yes, as long as you feel comfortable. We have good experience with pregnant clients and arrange the treatment so you lie comfortably throughout.'
        },
        {
          q: 'Is it safe to have a lash lift if I\'m pregnant?',
          a: 'Yes, but we have some guidelines: We do not perform lash lifts on pregnant women in the first trimester (the first 12 weeks), as the body undergoes major hormonal changes. After the first trimester, we can perform the treatment, but we ask you to send us an email before the appointment confirming that you take the treatment at your own risk. Be aware that hormonal changes during pregnancy can affect the result. Let us know in advance, and we\'ll assess together what is safest.'
        },
        {
          q: 'Does pregnancy affect treatment results?',
          a: 'Hormonal changes during pregnancy can affect both skin and hair growth. Some experience that lash lifts or brow lamination don\'t last as long, while others notice no difference. We always inform you about this before the treatment.'
        },
        {
          q: 'Can I lie however I want during treatment?',
          a: 'Of course. You can lie on your side, take breaks or adjust along the way – we adapt to you 🤍'
        },
        {
          q: 'Do you accommodate pregnant clients?',
          a: 'Yes! We always do what we can to make you feel safe and comfortable throughout the treatment.'
        },
        {
          q: 'Is there anything I should think about as a pregnant woman before treatment?',
          a: 'The most important thing is to listen to your body 🤍 Please let us know if you are extra sensitive or need breaks, and we\'ll adapt the treatment accordingly.'
        },
        {
          q: 'What if I feel dizzy, unwell or need a break during treatment?',
          a: 'That\'s completely ok 🤍 Let us know right away. If you need to close your eyes or feel unwell, we\'ll stop, help you down calmly and give you time to recover.'
        },
        {
          q: 'What if I need to use the bathroom during treatment?',
          a: 'That\'s perfectly fine 🤍 Just let us know. If you\'re in a treatment where you need to keep your eyes closed (like lash lift), we\'ll help you and guide you safely to the bathroom. We always adapt the treatment to you and make sure you feel comfortable the whole way 🤍'
        }
      ],
      firstTime: [
        {
          q: 'What can I expect the first time?',
          a: 'You\'ll be warmly welcomed and guided through the entire treatment. We explain as we go and adapt to you.'
        },
        {
          q: 'What if I\'m unsure or have questions?',
          a: 'Ask us! We\'re here to help you and make the experience as safe and comfortable as possible 🤍'
        }
      ],
      courses: [
        {
          q: 'Where are the courses held?',
          a: 'All courses are held in our salon at Veiten 2B, Bergen city center 🤍'
        },
        {
          q: 'Can you come to us and hold a course?',
          a: 'Yes! I can travel to you, including to Northern Norway. This must be agreed in advance, and price is adjusted for travel, flights, hotel and stay.'
        },
        {
          q: 'How long does a course last?',
          a: 'Courses last about one working day (5–7 hours), depending on the type of course.'
        },
        {
          q: 'What\'s included in the course?',
          a: 'Theory and practical training, working on a model, diploma after completion, lunch 🤍 and follow-up afterwards.'
        },
        {
          q: 'Do you provide follow-up after the course?',
          a: 'Yes 🤍 You\'ll be added to an exclusive group with former students, where I share tips and techniques, favorite products, news, recommendations and extra learning. You can also always contact me if you need help after the course.'
        },
        {
          q: 'Can I bring my own model?',
          a: 'Yes, you can 🤍 If not, we can help with a model if needed.'
        },
        {
          q: 'When do I need to pay for the course?',
          a: 'The full course fee must be paid before the course date. Your spot is secured when payment is completed.'
        },
        {
          q: 'Do you have package prices for multiple courses or participants?',
          a: 'Currently we don\'t offer package prices, all courses are priced per person.'
        },
        {
          q: 'Can I take the course online?',
          a: 'I\'m actively working on creating online courses 🤍 The theory part will soon be available digitally and give a theory diploma. For the best learning, we still recommend physical courses in the salon to practice technique and work on models.'
        },
        {
          q: 'Do you use specific products in courses?',
          a: 'Yes, all courses are held with products from Italwax.'
        },
        {
          q: 'Do you get a goodie bag at the course?',
          a: 'I\'m working on this 🤍 In the future, all courses will include a goodie bag, and I\'ll also send to former students who didn\'t receive one.'
        },
        {
          q: 'Do you have a toilet in the salon?',
          a: 'Yes 🤍'
        },
        {
          q: 'Do we get lunch during the course?',
          a: 'Yes, lunch is included.'
        },
        {
          q: 'Do I need previous experience?',
          a: 'No 🤍 The courses are suitable for both beginners and those who want to develop further.'
        },
        {
          q: 'Do I get a diploma after the course?',
          a: 'Yes, you\'ll receive a diploma from Just Peachy Bergen after completing the course.'
        },
        {
          q: 'Can I work with this after the course?',
          a: 'Yes! The course gives you a good foundation to work with the treatments, but it\'s important to keep practicing to become confident and fast.'
        },
        {
          q: 'What makes your courses different?',
          a: 'With us you don\'t just get a course, you get real follow-up, honest tips and techniques that actually work in a salon.'
        }
      ],
      trainees: [
        {
          q: 'What are trainee treatments?',
          a: 'These are treatments performed by students in training with us, under close supervision.'
        },
        {
          q: 'Is the quality just as good?',
          a: 'Yes, we use the same products and techniques as usual. Everything is quality checked along the way.'
        }
      ],
      reviews: [
        {
          q: 'What if I\'m not satisfied?',
          a: 'Let us know 🤍 We really appreciate feedback – that\'s how we can improve and make things right. All we ask is that feedback is given in a kind way. We\'re human too, and we always want to help you regardless.'
        },
        {
          q: 'Where can I leave a review?',
          a: 'You can leave a review on Google or Timma – we\'re so happy and check all the time 😭🤍'
        },
        {
          q: 'What if I want to leave a negative review?',
          a: 'Please contact us first. We\'ll always do our best to find a solution you\'re happy with.'
        }
      ],
      jobs: [
        {
          q: 'How do I apply for a job with you?',
          a: 'Send an email to info@justpeachybergen.no with subject "Job Application" 🤍'
        },
        {
          q: 'Do I need experience to work with you?',
          a: 'No. What matters most to us is who you are as a person. For me (Kamilla), it\'s most important that you\'re friendly, positive, a good colleague and contribute to a good work environment. All treatments can be learned 🤍 But how you are as a person can\'t be learned the same way. I\'m very particular about who gets to work with us, because it\'s important to me that both I and the team enjoy and look forward to coming to work.'
        }
      ],
      gelNails: [
        {
          q: 'Why can\'t I book "Nail Removal" online?',
          a: 'This is because Thea is allergic to a type of gel that many salons use. To prevent clients from arriving with nails Thea can\'t work on due to her allergy, we ask that you contact us to book this specific treatment. That way we can make sure together that your nails are safe for Thea to work with 🤍 Feel free to email info@justpeachybergen.no or DM us on Instagram @justpeachy_bergen and we will help you book.'
        },
        {
          q: 'How do I book a gel nail appointment with Thea?',
          a: 'New gel nails or refills can be booked easily through our booking system. For removal of nails applied elsewhere, you need to contact us first — so we can make sure the gel on your nails isn\'t a type Thea is allergic to. Send us a message at info@justpeachybergen.no or on Instagram, and tell us which salon you last visited if you remember. We will find a time for you 💅'
        },
        {
          q: 'What type of gel does Thea use?',
          a: 'Thea uses a high-quality gel that she tolerates well and that gives a beautiful, long-lasting result. She avoids types of gel that trigger her allergy, so she is careful about which nails she removes or works over — especially if you have had nails applied at another salon whose product we don\'t recognise.'
        },
        {
          q: 'Can I get a refill on nails done elsewhere?',
          a: 'We recommend that you contact us before booking a refill of nails made elsewhere so we can identify the product. In many cases we will recommend full removal and a fresh set — both out of consideration for Thea\'s allergy and to ensure the result is as beautiful and long-lasting as possible 🤍'
        }
      ],
      general: [
        {
          q: 'I\'ve booked an appointment but haven\'t received a confirmation email, what do I do?',
          a: 'First: check your spam/junk folder. Sometimes the confirmation ends up there. If you still can\'t find it, send us a message on Instagram or email with your full name, phone number and the email address you used when booking. We\'ll check your profile in our system and resend the booking confirmation.'
        },
        {
          q: 'Can I reschedule my appointment myself?',
          a: 'Not quite! You need to send us a message if you want to change the time or treatment. We\'re happy to help! Send us a DM on Instagram or an email with your full name and the time you want to change, and we\'ll fix it.'
        },
        {
          q: 'I\'ve been to another salon and got a failed result. Can I have a new treatment with you?',
          a: 'Yes, you can! But we recommend that you come in for a short consultation first, so we can look at your lashes and assess whether they can handle a new treatment right away. We are used to working with both complaints and more challenging lashes, and have good experience in correcting difficult results from other salons.'
        },
        {
          q: 'Do you sell products?',
          a: 'Yes, we have carefully selected products for aftercare 🤍'
        },
        {
          q: 'Can I buy gift cards?',
          a: 'Yes! Perfect gift 🎁 You can buy via Vipps to Just Peachy Bergen AS (Vipps #963957).'
        }
      ],
      ctaTitle: 'Couldn\'t find your answer?',
      ctaDesc: 'Feel free to contact us and we\'ll help you!',
      ctaButton: 'Contact Us'
    }
  }
};
